<template>
  <fragment>
    <g id="C-1-3-1_gakuran" v-if="data.clothes.value === 'type-15'">
      <g clip-path="url(#clippath-11)">
        <g>
          <path
            d="M216.36,268.69c-5.03-3.19-32.04-13.12-32.04-13.12v-4.28c0-1.09-.99-1.88-1.98-1.67-4.61,.94-16.02,3.12-23.11,3.12s-18.5-2.17-23.11-3.12c-1.06-.22-1.98,.58-1.98,1.67v4.28s-26.93,9.93-32.04,13.12c-2.62,1.67-34.02,80.95-34.02,80.95,1.06,5.15,29.91,6.23,29.91,6.23,9,5.51,113.47,5.51,122.47,0,0,0,28.85-1.09,29.91-6.23,0-.07-31.4-79.36-34.02-80.95Z"
          />
          <path
            d="M216.36,268.69c-5.03-3.19-32.04-13.12-32.04-13.12v-4.28c0-1.09-.99-1.88-1.98-1.67-4.61,.94-16.02,3.12-23.11,3.12s-18.5-2.17-23.11-3.12c-1.06-.22-1.98,.58-1.98,1.67v4.28s-26.93,9.93-32.04,13.12c-2.62,1.67-4.11,87.19-4.11,87.19,9,5.51,113.47,5.51,122.47,0,0,0-1.49-85.59-4.11-87.19Z"
            fill="#2b2b2b"
          />
          <ellipse cx="159.23" cy="272.61" rx="7.16" ry="6.6" fill="#d9c581" />
          <ellipse cx="159.23" cy="302.97" rx="7.16" ry="6.6" fill="#d9c581" />
        </g>
      </g>
    </g>
    <g id="C-1-3-2_sailor" v-if="data.clothes.value === 'type-16'">
      <g clip-path="url(#clippath-12)">
        <path
          d="M162.75,295.7l20.2-27.38c1.39-1.88,.04-4.54-2.29-4.54h-40.4c-2.34,0-3.68,2.66-2.29,4.54l20.2,27.38c1.14,1.54,3.45,1.54,4.59,0Z"
          fill="#efefef"
        />
        <g>
          <path
            d="M213.24,265.09c-5.19-4.23-39.18-14.51-39.18-14.51l-14.77,49.11-14.83-49.11s-33.99,10.28-39.18,14.51-30.21,67.31-24.53,78.08H237.77c5.68-10.77-19.34-73.9-24.53-78.08Z"
            fill="#efefef"
          />
          <path
            d="M213.24,265.09c-5.19-4.23-39.18-14.51-39.18-14.51l-14.77,49.11-14.83-49.11s-33.99,10.28-39.18,14.51-5.19,78.08-5.19,78.08h119.48s-1.16-73.9-6.35-78.08Z"
            fill="#f9f9f9"
          />
          <path
            d="M159.3,297.87l-38.14-13.06s5.8,20.8,11.05,22.92,27.52-4.35,27.52-4.35c0,0,21.48,6.47,26.73,4.35s11.05-22.92,11.05-22.92l-38.2,13.06Z"
            fill="#d80051"
          />
          <path
            d="M173.27,249.55l-13.97,40.34-13.97-40.34-37.16,10.89s1.16,39.25,51.14,39.25,51.14-39.25,51.14-39.25l-37.16-10.89Z"
            fill="#0c42c8"
          />
          <path
            d="M206.1,259.22s-1.59,30.9-46.8,35.08c-45.22-4.23-46.8-35.08-46.8-35.08l-1.89,.54c2.81,34.77,48.7,36.71,48.7,36.71,0,0,45.95-1.94,48.7-36.71l-1.89-.54Z"
            fill="#fff"
          />
          <path
            d="M154.42,303.37s-8.54,23.22-8.48,39.79h27.46s-1.22-29.21-6.9-37.62c-3.78-5.56-12.08-2.18-12.08-2.18Z"
            fill="#d80051"
          />
          <path
            d="M169.85,309.6c.37,.79-.12,1.63-.98,1.75-2.2,.36-6.04,.97-8.42,.97s-6.22-.54-8.42-.91c-.85-.12-1.34-1.03-.98-1.75l1.83-4.11c.18-.48,.67-.79,1.16-.79h6.41c1.77,0,5.06,.12,6.53,.18,.49,0,.92,.3,1.16,.79l1.71,3.87Z"
            fill="#fff"
            stroke="#bcbcbc"
            stroke-miterlimit="10"
          />
          <path
            d="M158.32,342.02c-3.05-13.79-1.59-27.09-1.59-27.09"
            fill="none"
            stroke="#a50043"
            stroke-linecap="round"
            stroke-miterlimit="10"
          />
        </g>
      </g>
    </g>
    <g id="C-1-3-3_tuxedo" v-if="data.clothes.value === 'type-17'">
      <polygon
        points="147.88 247.99 159.22 250.87 171.24 247.37 179.42 254.64 159.22 308.76 139.44 256.82 147.88 247.99"
        fill="#fff"
      />
      <g clip-path="url(#clippath-13)">
        <g id="clothe">
          <polygon
            points="147.22 248.95 145.6 267.15 159.06 302.8 172.77 263.39 172.16 250.61 172.63 249.54 177.09 268.38 169.32 301.02 158.15 307.8 147.17 301.52 140.89 268.58 146.28 249.49 147.22 248.95"
            fill="#ddddd4"
          />
          <rect
            x="158.92"
            y="250.87"
            width=".3"
            height="62.07"
            fill="#ddddd4"
          />
          <polygon
            points="140 255.94 159.25 304.86 177.98 255.68 183.02 343.91 132.18 343.91 140 255.94"
            fill="#b2b29e"
          />
          <polygon
            points="175.73 257.52 158.46 306.18 158.46 343.91 175.73 343.91 175.73 257.52"
            fill="#c1c1b4"
          />
          <circle cx="165.25" cy="313.37" r="3.36" fill="#5b5b51" />
          <path
            d="M122.58,258.83c-18.38,.86-34.24,68.58-39.1,84.13-3.8,7.78,33.92,23.77,39.27,3.9,5.35-19.87,23.11-89.12-.18-88.04Z"
            fill="#f9f7d2"
          />
          <path
            d="M196.11,258.83c14.5,.46,42.2,71.08,33.46,88.83,3.8,7.78-25.15,31.74-30.5,11.87-5.35-19.87-26.26-101.44-2.96-100.69Z"
            fill="#f9f7d2"
          />
          <path
            d="M144.25,273.25c.68-12.17,1.41-20.13,2.6-24.87-4.35,1.64-21.08,7.87-25.49,10.67-2.96,1.88-7.78,35.03-7.35,41.68,.37,5.14-3.33,64.8-3.33,64.8h35.16s-2.32-79.1-1.59-92.27Z"
            fill="#feffe9"
          />
          <path
            d="M140.39,251.03l-10.58,16.52,5.74,2.97-6.03,2.77c.9,9.87,1.29,23.84,3.56,35.6,1.38,7.14,10.88,27.49,10.88,27.49l-5.54-35.51,2.57-34.62,3.46-13.55-4.05-1.68Z"
            fill="#f7eec1"
          />
          <polygon
            points="146.93 247.91 144.42 270.19 131.36 265.83 140.2 250.14 146.93 247.91"
            fill="#fffff8"
          />
          <path
            d="M144.65,265.37l-13.76,6.13s2.13,31.19,4.07,39.36,10.25,31.65,10.25,31.65c0,0-.26-31.55-.46-42.33-.2-10.78-.1-34.81-.1-34.81Z"
            fill="#fffff8"
          />
          <path
            d="M174.28,273.25c-.68-12.17-1.41-20.13-2.6-24.87,4.35,1.64,21.08,7.87,25.49,10.67,2.96,1.88,7.78,35.03,7.35,41.68-.37,5.14,3.33,64.8,3.33,64.8h-35.16s2.32-79.1,1.59-92.27Z"
            fill="#feffe9"
          />
          <path
            d="M178.06,251.03l10.58,16.52-5.74,2.97,6.03,2.77c-.9,9.87-1.29,23.84-3.56,35.6-1.38,7.14-10.88,27.49-10.88,27.49l5.54-35.51-2.57-34.62-3.46-13.55,4.05-1.68Z"
            fill="#f7eec1"
          />
          <polygon
            points="171.52 247.91 174.03 270.19 187.09 265.83 178.25 250.14 171.52 247.91"
            fill="#fffff8"
          />
          <rect
            x="181.24"
            y="281.29"
            width="17.6"
            height="7.62"
            fill="none"
            stroke="#e2cf7f"
            stroke-miterlimit="10"
            stroke-width=".91"
          />
          <path
            d="M173.8,265.37l13.76,6.13s-2.13,31.19-4.07,39.36c-1.9,8-10.25,31.65-10.25,31.65,0,0,.26-31.55,.46-42.33s.1-34.81,.1-34.81Z"
            fill="#fffff8"
          />
          <path
            d="M147.34,246.55l11.66,4.28-7.01,10.02-3.76-5.32c-1.29-3.69-1.41-6.62-1.48-7l.59-1.97Z"
            fill="#ddddd4"
          />
          <path
            d="M172.11,249.18l-13.11,1.65,8.38,10.02,3.97-4.43c.77-1.64,1.09-4.66,1.17-5.04l-.41-2.2Z"
            fill="#ddddd4"
          />
          <path
            d="M147.25,246.18l11.74,4.65-7.01,7.02-3.97-4.43c-.77-1.64-1.09-4.66-1.17-5.04l.41-2.2Z"
            fill="#fff"
          />
          <path
            d="M172.11,246.18l-13.11,4.65,8.38,7.02,3.97-4.43c.77-1.64,1.09-4.66,1.17-5.04l-.41-2.2Z"
            fill="#fff"
          />
          <path
            d="M160.29,257.94s5.56-5.67,7.72-5.5c1.57,.13,2.43,3.82,2.33,5.96-.1,2.17-.48,5.32-1.19,5.88-.8,.63-8.86-3.53-8.86-3.53v-2.81Z"
            fill="#ddddd4"
          />
          <path
            d="M158.66,257.94s-5.56-5.67-7.72-5.5c-1.57,.13-2.43,3.82-2.33,5.96,.1,2.17,.48,5.32,1.19,5.88,.8,.63,8.86-3.53,8.86-3.53v-2.81Z"
            fill="#ddddd4"
          />
          <rect
            x="156.49"
            y="257.06"
            width="6.01"
            height="4.38"
            rx="1.95"
            ry="1.95"
            fill="#ddddd4"
          />
          <path
            d="M160.29,256.94s5.56-5.67,7.72-5.5c1.57,.13,2.43,3.82,2.33,5.96-.1,2.17-.48,5.32-1.19,5.88-.8,.63-8.86-3.53-8.86-3.53v-2.81Z"
            fill="#fcfbcd"
          />
          <path
            d="M158.66,256.94s-5.56-5.67-7.72-5.5c-1.57,.13-2.43,3.82-2.33,5.96,.1,2.17,.48,5.32,1.19,5.88,.8,.63,8.86-3.53,8.86-3.53v-2.81Z"
            fill="#fcfbcd"
          />
          <path
            d="M166.08,257.84s-4.98-1.7-4.91-.06c.08,1.85,4.91,.06,4.91,.06Z"
            fill="#f4eb98"
          />
          <path
            d="M152.59,257.9s4.64-.89,4.57,.2c-.1,1.44-4.57-.2-4.57-.2Z"
            fill="#f4eb98"
          />
          <rect
            x="156.49"
            y="256.06"
            width="6.01"
            height="4.38"
            rx="1.95"
            ry="1.95"
            fill="#fffee3"
          />
        </g>
      </g>
    </g>
    <g id="C-1-3-4_wedding_dress" v-if="data.clothes.value === 'type-18'">
      <g clip-path="url(#clippath-14)">
        <g>
          <g id="body22">
            <path
              d="M112.86,269.44c-4.94,17.07-23.72,75.88-23.72,86.51s15.48,12.68,19.07,2.36,25.46-65.89,29.74-80.02-20.14-25.92-25.09-8.85Z"
              :fill="data.skin.value"
            />
            <path
              d="M205.58,269.44c4.94,17.07,23.72,75.88,23.72,86.51s-15.48,12.68-19.07,2.36-25.46-65.89-29.74-80.02c-4.28-14.13,20.14-25.92,25.09-8.85Z"
              :fill="data.skin.value"
            />
            <path
              d="M172.66,252.12c-.48,4.02-2.7-7.51-.99-5.31,3.4,4.37,16.63,6.03,27.71,12.93,5.76,3.58,5.61,11.74,4.65,24.72-.89,12.01-5.17,76.96-5.17,76.96H118.87s-3.3-64.93-4.19-76.96c-.42-6.34-.82-10.65-.19-15.88,.56-4.11,1.97-7.04,4.84-8.84,7.62-4.74,16.25-7.01,22.01-9.38,2.16-.92,4.37-1.9,5.7-3.54,1.71-2.2-2.91,6.66,1.75,6.17l23.87-.87Z"
              :fill="data.skin.value"
            />
            <g id="arm_group_left">
              <ellipse
                cx="102.45"
                cy="315.16"
                rx="1.14"
                ry="2.37"
                transform="translate(-115.55 65.56) rotate(-23.13)"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <ellipse
                cx="104.52"
                cy="319.61"
                rx="1.14"
                ry="2.37"
                transform="translate(-117.13 66.74) rotate(-23.13)"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <ellipse
                cx="104.67"
                cy="311.24"
                rx="2.37"
                ry="1.14"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <path
                d="M101.81,306.12c.49,.16,2-.81,2.21-.58,.43,.46-.02,1.02-.5,2.24s-.97,1.9-1.56,1.67c-.31-.12-.39-.73-.87-.87"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <path
                d="M105.86,303.55c-.48,1.22-1.34,2.02-1.93,1.79s-1.09-1.36-.61-2.58,1.76-2.07,2.34-1.84,.67,1.41,.19,2.63Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <path
                d="M100.75,309.65c.66,.19,1.13,.86,1.13,1.6,0,.94-.76,1.69-1.69,1.69-.14,0-.27-.01-.39-.05"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <g>
                <ellipse
                  cx="115.97"
                  cy="315.38"
                  rx="1.14"
                  ry="2.37"
                  transform="translate(-114.55 70.89) rotate(-23.13)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="111.62"
                  cy="307.27"
                  rx="1.14"
                  ry="2.37"
                  transform="translate(-111.72 68.53) rotate(-23.13)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="109.01"
                  cy="302.76"
                  rx="1.14"
                  ry="2.37"
                  transform="translate(-110.15 67.15) rotate(-23.13)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="118.05"
                  cy="319.83"
                  rx="1.14"
                  ry="2.37"
                  transform="translate(-116.13 72.07) rotate(-23.13)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="108.53"
                  cy="319.83"
                  rx="2.37"
                  ry="1.14"
                  transform="translate(-228.85 304.02) rotate(-68.57)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="111.17"
                  cy="315.24"
                  rx="2.37"
                  ry="1.14"
                  transform="translate(-222.89 303.57) rotate(-68.57)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="109.2"
                  cy="311.15"
                  rx="2.37"
                  ry="1.14"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="118.2"
                  cy="311.46"
                  rx="2.37"
                  ry="1.14"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="115.97"
                  cy="307.58"
                  rx="2.37"
                  ry="1.14"
                  transform="translate(-212.71 303.17) rotate(-68.57)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="118.32"
                  cy="303.35"
                  rx="2.37"
                  ry="1.14"
                  transform="translate(-207.29 302.67) rotate(-68.57)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <circle
                  cx="113.71"
                  cy="311.47"
                  r="1.69"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
              </g>
            </g>
            <g id="arm_right">
              <g>
                <ellipse
                  cx="209.39"
                  cy="311.39"
                  rx="1.14"
                  ry="2.37"
                  transform="translate(-105.48 107.27) rotate(-23.13)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="205.04"
                  cy="303.28"
                  rx="1.14"
                  ry="2.37"
                  transform="translate(-102.64 104.91) rotate(-23.13)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="202.44"
                  cy="298.77"
                  rx="1.14"
                  ry="2.37"
                  transform="translate(-101.08 103.52) rotate(-23.13)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="211.47"
                  cy="315.84"
                  rx="1.14"
                  ry="2.37"
                  transform="translate(-107.06 108.44) rotate(-23.13)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="201.95"
                  cy="315.84"
                  rx="2.37"
                  ry="1.14"
                  transform="translate(-165.84 388.45) rotate(-68.57)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="204.6"
                  cy="311.25"
                  rx="2.37"
                  ry="1.14"
                  transform="translate(-159.88 388) rotate(-68.57)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="202.62"
                  cy="307.16"
                  rx="2.37"
                  ry="1.14"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="211.62"
                  cy="307.47"
                  rx="2.37"
                  ry="1.14"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="209.4"
                  cy="303.59"
                  rx="2.37"
                  ry="1.14"
                  transform="translate(-149.7 387.6) rotate(-68.57)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="211.74"
                  cy="299.36"
                  rx="2.37"
                  ry="1.14"
                  transform="translate(-144.28 387.11) rotate(-68.57)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <circle
                  cx="207.14"
                  cy="307.48"
                  r="1.69"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
              </g>
              <ellipse
                cx="215.48"
                cy="316.06"
                rx="2.37"
                ry="1.14"
                transform="translate(-157.46 401.18) rotate(-68.57)"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <path
                d="M218.65,312.88c-.73,.23-.99,.95-1.39,.79-.59-.23-.67-1.41-.19-2.63,.19-.47,.3-1.08,.69-1.19"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <path
                d="M217.31,308.37c-.34,.09-.74,.15-1.17,.15-1.31,0-2.37-.51-2.37-1.14s1.06-1.14,2.37-1.14c.19,0,.38,.09,.54,.03"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <g>
                <ellipse
                  cx="202.41"
                  cy="320.59"
                  rx="1.14"
                  ry="2.37"
                  transform="translate(-109.65 105.26) rotate(-23.13)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
                <ellipse
                  cx="211.71"
                  cy="321.18"
                  rx="2.37"
                  ry="1.14"
                  transform="translate(-164.61 400.93) rotate(-68.57)"
                  fill="none"
                  stroke="#fff"
                  stroke-miterlimit="10"
                />
              </g>
              <ellipse
                cx="215.93"
                cy="320.81"
                rx="1.14"
                ry="2.37"
                transform="translate(-108.65 110.59) rotate(-23.13)"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
            </g>
          </g>
          <g>
            <ellipse
              cx="147.5"
              cy="267.48"
              rx="1.16"
              ry="2.71"
              transform="translate(-78.03 61.47) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="143.14"
              cy="258.04"
              rx="1.16"
              ry="2.71"
              transform="translate(-75.23 59.57) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <path
              d="M141.59,252.27c.51,1.4,.46,2.77-.12,3.06s-1.47-.62-1.98-2.02-.4-1.56,.18-1.85,1.41-.6,1.92,.8Z"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="149.57"
              cy="272.66"
              rx="1.16"
              ry="2.71"
              transform="translate(-79.58 62.41) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="140.05"
              cy="272.66"
              rx="2.72"
              ry="1.16"
              transform="translate(-161.92 325.29) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="142.7"
              cy="267.31"
              rx="2.72"
              ry="1.16"
              transform="translate(-154.96 324.06) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="140.72"
              cy="262.55"
              rx="2.37"
              ry="1.33"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="149.72"
              cy="262.91"
              rx="2.37"
              ry="1.33"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="147.5"
              cy="258.39"
              rx="2.72"
              ry="1.16"
              transform="translate(-143.07 322.37) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="149.85"
              cy="253.47"
              rx="2.72"
              ry="1.16"
              transform="translate(-136.72 321.16) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="145.24"
              cy="262.92"
              rx="1.69"
              ry="1.97"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
          </g>
          <g>
            <ellipse
              cx="132.92"
              cy="267.29"
              rx="1.16"
              ry="2.71"
              transform="translate(-78.74 56.78) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <path
              d="M128.12,255.31c.22,.51,1.11,.97,1.5,2.02,.51,1.4,.46,2.77-.12,3.06s-1.47-.62-1.98-2.02c-.4-1.1,.02-2.26-.19-2.73"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="135"
              cy="272.48"
              rx="1.16"
              ry="2.71"
              transform="translate(-80.29 57.72) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="125.48"
              cy="272.48"
              rx="2.72"
              ry="1.16"
              transform="translate(-171.98 311.25) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="128.13"
              cy="267.13"
              rx="2.72"
              ry="1.16"
              transform="translate(-165.02 310.02) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="126.15"
              cy="262.37"
              rx="2.37"
              ry="1.33"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="135.15"
              cy="262.72"
              rx="2.37"
              ry="1.33"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="132.92"
              cy="258.21"
              rx="2.72"
              ry="1.16"
              transform="translate(-153.13 308.33) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <path
              d="M136.64,252.12c.16,.47-.11,1.07-.31,1.65-.48,1.42-1.34,2.36-1.93,2.09s.17-1.72-.26-2.85"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="130.67"
              cy="262.74"
              rx="1.69"
              ry="1.97"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
          </g>
          <g>
            <ellipse
              cx="162.35"
              cy="267.48"
              rx="1.16"
              ry="2.71"
              transform="translate(-77.24 66.24) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="157.99"
              cy="258.04"
              rx="1.16"
              ry="2.71"
              transform="translate(-74.44 64.34) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="155.39"
              cy="252.79"
              rx="1.16"
              ry="2.71"
              transform="translate(-72.9 63.23) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="164.42"
              cy="272.66"
              rx="1.16"
              ry="2.71"
              transform="translate(-78.79 67.18) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="154.9"
              cy="272.66"
              rx="2.72"
              ry="1.16"
              transform="translate(-151.49 339.47) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="157.55"
              cy="267.31"
              rx="2.72"
              ry="1.16"
              transform="translate(-144.52 338.24) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="155.57"
              cy="262.55"
              rx="2.37"
              ry="1.33"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="164.57"
              cy="262.91"
              rx="2.37"
              ry="1.33"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="162.35"
              cy="258.39"
              rx="2.72"
              ry="1.16"
              transform="translate(-132.63 336.55) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="164.7"
              cy="253.47"
              rx="2.72"
              ry="1.16"
              transform="translate(-126.29 335.34) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="160.09"
              cy="262.92"
              rx="1.69"
              ry="1.97"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
          </g>
          <g>
            <ellipse
              cx="176.61"
              cy="267.99"
              rx="1.16"
              ry="2.71"
              transform="translate(-76.65 70.84) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="172.26"
              cy="258.55"
              rx="1.16"
              ry="2.71"
              transform="translate(-73.85 68.94) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="169.65"
              cy="253.3"
              rx="1.16"
              ry="2.71"
              transform="translate(-72.3 67.83) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="178.68"
              cy="273.17"
              rx="1.16"
              ry="2.71"
              transform="translate(-78.2 71.78) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="169.17"
              cy="273.17"
              rx="2.72"
              ry="1.16"
              transform="translate(-141.95 353.45) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="171.81"
              cy="267.82"
              rx="2.72"
              ry="1.16"
              transform="translate(-134.99 352.22) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="169.83"
              cy="263.06"
              rx="2.37"
              ry="1.33"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="178.83"
              cy="263.42"
              rx="2.37"
              ry="1.33"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="176.61"
              cy="258.9"
              rx="2.72"
              ry="1.16"
              transform="translate(-123.1 350.53) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="178.96"
              cy="253.98"
              rx="2.72"
              ry="1.16"
              transform="translate(-116.75 349.31) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="174.35"
              cy="263.43"
              rx="1.69"
              ry="1.97"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
          </g>
          <g>
            <ellipse
              cx="190.89"
              cy="268.62"
              rx="1.16"
              ry="2.71"
              transform="translate(-76.1 75.45) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="186.53"
              cy="259.18"
              rx="1.16"
              ry="2.71"
              transform="translate(-73.3 73.56) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <path
              d="M184.86,253.12c-.03,.1-.07,.31-.03,.41,.51,1.4,.61,2.66,.03,2.94s-1.47-.62-1.98-2.02c-.29-.79-.54-1.61-.34-2.16"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="192.96"
              cy="273.8"
              rx="1.16"
              ry="2.71"
              transform="translate(-77.65 76.39) rotate(-18.72)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="183.44"
              cy="273.8"
              rx="2.72"
              ry="1.16"
              transform="translate(-132.52 367.52) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="186.09"
              cy="268.46"
              rx="2.72"
              ry="1.16"
              transform="translate(-125.56 366.29) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="184.11"
              cy="263.7"
              rx="2.37"
              ry="1.33"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="193.11"
              cy="264.05"
              rx="2.37"
              ry="1.33"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="190.89"
              cy="259.53"
              rx="2.72"
              ry="1.16"
              transform="translate(-113.67 364.6) rotate(-72.7)"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <path
              d="M193.52,256.6c-.28,.63-.8,.75-1.15,.59-.33-.15-.74-.71-.5-1.33"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
            <ellipse
              cx="188.63"
              cy="264.06"
              rx="1.69"
              ry="1.97"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="1.08"
            />
          </g>
          <ellipse
            cx="118.33"
            cy="266.93"
            rx="1.16"
            ry="2.71"
            transform="translate(-79.39 52.08) rotate(-18.72)"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1.08"
          />
          <ellipse
            cx="120.41"
            cy="272.12"
            rx="1.16"
            ry="2.71"
            transform="translate(-80.95 53.02) rotate(-18.72)"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1.08"
          />
          <ellipse
            cx="110.89"
            cy="272.12"
            rx="2.72"
            ry="1.16"
            transform="translate(-181.89 297.07) rotate(-72.7)"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1.08"
          />
          <ellipse
            cx="120.56"
            cy="262.36"
            rx="2.37"
            ry="1.33"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1.08"
          />
          <path
            d="M117.47,261.26c.27,.25,.3,.7,.3,1.12,0,1.09-.76,1.97-1.69,1.97-.17,0-.35,0-.5-.09"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1.08"
          />
          <ellipse
            cx="205.3"
            cy="268.79"
            rx="1.16"
            ry="2.71"
            transform="translate(-75.39 80.09) rotate(-18.72)"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1.08"
          />
          <path
            d="M201.69,261.78c-1.01,.81-2.48-.46-1.68-1.61"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1.08"
          />
          <ellipse
            cx="207.37"
            cy="273.98"
            rx="1.16"
            ry="2.71"
            transform="translate(-76.95 81.03) rotate(-18.72)"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1.08"
          />
          <ellipse
            cx="197.85"
            cy="273.98"
            rx="2.72"
            ry="1.16"
            transform="translate(-122.57 381.4) rotate(-72.7)"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1.08"
          />
          <ellipse
            cx="200.5"
            cy="268.63"
            rx="2.72"
            ry="1.16"
            transform="translate(-115.6 380.17) rotate(-72.7)"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1.08"
          />
          <ellipse
            cx="198.52"
            cy="263.87"
            rx="2.37"
            ry="1.33"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1.08"
          />
          <path
            d="M203.67,266.06c-.2,.09-.41,.14-.64,.14-.94,0-1.69-.88-1.69-1.97,0-.74,.3-1.36,.87-1.72"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1.08"
          />
          <path
            d="M85.21,361.5l20.02,6.28,22.25-54.85s-8.97,1.06-16.12-1.61-9.52-5.17-9.52-5.17l-16.62,55.35Z"
            fill="#fffef3"
          />
          <path
            d="M233.05,361.94l-19.41,6.39-20.26-56.76s4.47,.31,12.15-2.68c7.67-2.99,10.22-5.69,10.22-5.69l17.31,58.74Z"
            fill="#fffef3"
          />
          <path
            d="M201.98,328.35s1.29-29.58,1.66-34.72c.43-6.65-9.08-16.83-13.44-18.47-1.88-.71-19.34-.36-29.72,.08-10.38-.44-30.11-1.84-31.99-1.13-4.35,1.64-15.13,14.07-14.7,20.72,.37,5.14,1.74,33.53,1.74,33.53l-4.94,35.89h96.33l-4.94-35.89Z"
            fill="#fcffe9"
          />
          <path
            d="M114.26,303.13s-.61-10.78-.62-12.02c-.06-7.14-1.06-12.54-.72-13.26,1.42-2.97,12.98,3.1,16.22,4.12,7.32,2.31,24.58,1.18,32.59,1.22,8.01-.04,24.18,1.42,33.02-2.41,3.11-1.35,10.83-3.17,10.83-3.17,0,0-2.77,6.79-2.02,14.69,.16,1.7-.35,9.36-.35,9.36,0,0-7.93-5.58-14.13-8.5-18.87-8.87-29.87-8.77-29.87-8.77,0,0-13.76,1.52-27.02,8.77-6.54,3.58-17.92,9.97-17.92,9.97Z"
            fill="#f2f0b6"
          />
          <path
            d="M101.59,303.64c-.91,.19-3.3-4.48-3.3-5.41,.06-7.14,9.32-24.96,15-27.59,2.99-1.38,12.98,3.1,16.22,4.12,7.32,2.31,24.58,1.18,32.59,1.22,8.01-.04,24.18,1.42,33.02-2.41,3.11-1.35,7.84-4.56,10.83-3.17,5.24,2.42,12.93,17.42,13.67,25.32,.16,1.7-1.68,5.84-3.24,5.14-5.91-2.64-19.69-9.22-26.34-10.89-15.13-3.82-30.48-9.18-30.48-9.18,0,0-19.9,7.4-28.2,9.78-7.08,2.02-24.24,11.94-29.77,13.07Z"
            fill="#fcfccd"
          />
          <path
            d="M208.42,264.33c-3.18-1.38-8.2,1.83-11.51,3.17-9.4,3.82-29.19,6.91-37.71,6.96-8.52-.04-24.28-3.46-32.07-5.77-3.44-1.02-14.07-5.5-17.25-4.12-6.6,2.87-13.41,19.25-11.15,24.69,2.15,5.19,41.78-6.4,58.5-6.4,.13,0,1.02-.73,2.3-.76,.13,0,2.46,.66,2.59,.66,16.72,0,55.49,12.61,57.64,7.42,2.26-5.44-4.76-22.98-11.36-25.86Z"
            fill="#fefff3"
          />
          <path
            d="M154.15,277.99c.13,3.16-15.68-1-15.68-1,0,0,15.54-2.17,15.68,1"
            fill="#f2f0b6"
          />
          <path
            d="M187.3,277.04s-25.9-1.67-25.77,1.49c.13,3.16,25.77-1.49,25.77-1.49Z"
            fill="#f2f0b6"
          />
          <path
            d="M165.68,283.57h-12.51c-.91,0-1.7-.62-1.92-1.51s-.42-2.14-.42-3.73,.2-2.85,.42-3.73,1-1.51,1.92-1.51h12.51c.8,0,1.52,.48,1.82,1.22,.36,.89,.74,2.25,.74,4.03s-.38,3.14-.74,4.03c-.3,.74-1.02,1.22-1.82,1.22Z"
            fill="#fffef3"
          />
          <g>
            <g>
              <path
                d="M178.22,249.88c1.13,.18,2.64,1.87,2.64,1.87-3.87,2.4-11.19,4.42-20.93,4.42-10.34,0-17.86-1.79-20.72-4.95-.64-.71,2.44-.61,2.44-1.38s-2.13-1.77,.81-3.07c4.19-1.84,8.27,6.7,17.75,5.71,9.41-.98,15.37-8.55,18.36-5.46,1.44,1.49-.95,2.76-.35,2.86Z"
                fill="#fff"
              />
              <path
                d="M180.05,247.23c0,3.06-8.98,5.54-20.06,5.54s-20.06-2.48-20.06-5.54c0-1.05,1.36-2.11,2.95-2.56,.4-.11,.75-.21,1.23-.2,.75,.01,.97,.2,1.5,.56,.68,.46,.93,.32,2.1,.65,.45,.13-.95,2.68,.88,2.77,3.63,.18,3.57-1.37,4.68-1.41,1.57-.05,1.97,2.46,3.66,2.47,3.61,.03,3.42-2.78,5.16-2.9,3.07-.2,1.99,2.88,5,2.62,3.16-.27,2.36-2.5,4.14-2.94,.59-.15,.56,.39,1.59,.36,1.39-.04,2.45-.82,3.68-.8,1.92,.03,3.55,.72,3.55,1.38Z"
                fill="#fff"
              />
            </g>
            <g>
              <path
                d="M147.71,245.67s-.9,1.6-3.24,1.6-3.93-.02-3.93-.8c0-.5,.52-1.07,1.55-1.52,.58-.26,1.27-.48,2.23-.57s1.16,.75,1.83,.9c.97,.21,1.57,.39,1.57,.39Z"
                fill="#f2f0b6"
              />
              <path
                d="M148.26,249.35c.34,.85,.84,2.11,.18,2.11s-3.02-.28-3.18-1.95c-.08-.89,2.42-2.77,2.42-2.77,0,0-.15,.55,.08,1.26,.16,.51,.28,.77,.51,1.34Z"
                fill="#f2f0b6"
              />
              <path
                d="M155.78,249.86c-.24,1.5-.9,2.74-2.01,2.74s-1.51-1.28-2.01-2.74c-.67-1.98,.96-2.88,1.6-2.83,.53,.04,1.03,.15,1.27,.62,.39,.79,1.31,1.15,1.14,2.21Z"
                fill="#f2f0b6"
              />
              <path
                d="M164.37,249.26c0,1.9-.82,3.44-1.83,3.44s-1.83-1.54-1.83-3.44,.35-2.75,1.68-2.66c1.68,.11,1.99,.76,1.99,2.66Z"
                fill="#f2f0b6"
              />
              <path
                d="M172.54,248.73c0,1.52-2.57,3.61-3.29,3.61-1.02,0-.46-1.68-.09-3.18,.49-1.99,1.48-2.63,1.48-2.63,.73,.14,1.91,.67,1.91,2.2Z"
                fill="#f2f0b6"
              />
              <path
                d="M179.57,246.6c.62,.42,.18,1.06-1.5,1.06s-4.8-1.04-4.8-1.04c0,0,1.97-.85,2.85-.9,1.67-.1,2.62,.32,3.45,.88Z"
                fill="#f2f0b6"
              />
            </g>
          </g>
          <circle cx="176.82" cy="252.67" r="2.09" fill="#d1cac3" />
          <circle cx="174.82" cy="254.67" r="2.09" fill="#d1cac3" />
          <circle cx="171.46" cy="257.31" r="2.45" fill="#d1cac3" />
          <circle cx="167.2" cy="259.57" r="2.71" fill="#d1cac3" />
          <circle cx="141.58" cy="252.67" r="2.09" fill="#d1cac3" />
          <circle cx="143.58" cy="254.67" r="2.09" fill="#d1cac3" />
          <circle cx="146.94" cy="257.31" r="2.45" fill="#d1cac3" />
          <circle cx="151.2" cy="259.57" r="2.71" fill="#d1cac3" />
          <circle cx="159.43" cy="262.6" r="5.3" fill="#d1cac3" />
          <circle cx="176.82" cy="250.67" r="2.09" fill="#74b6e2" />
          <circle cx="174.82" cy="252.67" r="2.09" fill="#8ec8ef" />
          <circle cx="171.46" cy="255.31" r="2.45" fill="#9cd6f7" />
          <circle cx="167.2" cy="257.57" r="2.71" fill="#a7e6fc" />
          <circle cx="141.58" cy="250.67" r="2.09" fill="#74b6e2" />
          <circle cx="143.58" cy="252.67" r="2.09" fill="#8ec8ef" />
          <circle cx="146.94" cy="255.31" r="2.45" fill="#9cd6f7" />
          <circle cx="151.2" cy="257.57" r="2.71" fill="#a7e6fc" />
          <circle cx="159.43" cy="260.6" r="5.3" fill="#b3f1ff" />
          <path
            d="M154.96,259.63s-.85,1.88,1.28,4.33c.98,1.12,3.77,1.88,4.3,.82,.31-.62-1.09-.15-2.85-1.19-2.16-1.28-2.73-3.96-2.73-3.96Z"
            fill="#72d8f7"
          />
          <circle cx="161.73" cy="258.32" r="1.42" fill="#fff" />
          <circle cx="168" cy="256.6" r=".98" fill="#fff" />
          <circle cx="152" cy="256.6" r=".98" fill="#fff" />
        </g>
      </g>
    </g>
    <g id="C-1-3-4_19" v-if="data.clothes.value === 'type-19'">
      <defs>
        <clipPath id="clippath">
          <rect fill="none" width="320" height="320" />
        </clipPath>
      </defs>
      <g clip-path="url(#clippath)" fill="none">
        <g>
          <path
            fill="#d14646"
            d="m125.67,286.2s0,.05.04.04c0-.02,0-.04-.04-.04Z"
          />
          <path
            fill="#e27b7b"
            opacity=".33"
            isolation="isolate"
            d="m125.67,286.2s0,.05.04.04c0-.02,0-.04-.04-.04Z"
          />
          <path
            fill="#d14646"
            d="m116.87,286.8s-.05,0-.04.04c.02,0,.04,0,.04-.04Z"
          />
          <path
            fill="#e27b7b"
            opacity=".33"
            isolation="isolate"
            d="m116.87,286.8s-.05,0-.04.04c.02,0,.04,0,.04-.04Z"
          />
          <path fill="#d14646" d="m114.07,283v-.1s-.1.1,0,.1Z" />
          <path
            fill="#e27b7b"
            opacity=".33"
            isolation="isolate"
            d="m114.07,283v-.1s-.1.1,0,.1Z"
          />
          <path
            fill="#d14646"
            d="m130.87,280.1s0,.05.04.04c0-.02,0-.04-.04-.04Z"
          />
          <polygon
            fill="#d14646"
            points="125.47 262 125.44 261.97 125.37 262.1 125.47 262"
          />
          <polygon
            fill="#e27b7b"
            opacity=".33"
            isolation="isolate"
            points="125.47 262 125.44 261.97 125.37 262.1 125.47 262"
          />
          <path
            fill="#e27b7b"
            opacity=".33"
            isolation="isolate"
            d="m197.53,263.66s.02.02.04.03c0-.01-.01-.03-.04-.03Z"
          />
          <path
            fill="#d14646"
            d="m201.64,270.66s.06-.02.08-.03c-.03.01-.06.02-.08.03Z"
          />
          <path
            fill="#d14646"
            d="m197.58,263.7s-.01,0-.02-.01c0,0,0,.01,0,.01h.01Z"
          />
          <path
            fill="#d14646"
            d="m202.68,270.41c-.21,0-.41.03-.61.09-.12.03-.23.08-.34.13.14-.06.29-.11.44-.13.17-.05.34-.08.51-.09Z"
          />
          <path
            :fill="data.skin.value"
            d="m214.74,314.98c-1.64-8.79-3.53-24.18-7.67-33.38-6.21-11.88-22.01-21.71-22.01-21.71h0c-2.11-1.33-12.16-7.72-13.37-8.9-2.29,2.88-6.66,4.83-11.69,4.83-5.61,0-10.42-2.44-12.41-5.89-.17.35-.36.67-.59.97-.84,1.02-10.12,7.55-12.43,9h-.06s-15.8,9.81-22.01,21.7c-4.14,9.2-6.04,24.59-7.67,33.38-.68,3.67.22,8.75.24,9.17l54.72-5.63,54.72,5.63c.02-.41.92-5.5.24-9.17Z"
          />
          <path
            fill="#fff"
            d="m198.17,305c-.86-10.02-8.29-17.62-10.03-19.08-2.77-2.33-7.43-2.32-14.55-1.27h0c-.86.12-8,1.45-13.65,1.47-5.65-.03-12.79-1.35-13.65-1.47h0c-7.12-1.05-11.78-1.05-14.55,1.27-1.74,1.46-9.17,9.06-10.03,19.08-.62,7.27,1.1,13.21,2.09,15.93h72.28c1-2.73,2.71-8.67,2.09-15.93Z"
          />
          <g>
            <g>
              <circle fill="#ededed" cx="141.18" cy="258.62" r="2.33" />
              <circle fill="#fff" cx="141.72" cy="258.02" r="1.4" />
            </g>
            <g>
              <circle fill="#ededed" cx="144.81" cy="261.08" r="2.46" />
              <circle fill="#fff" cx="145.33" cy="260.46" r="1.48" />
            </g>
            <g>
              <circle fill="#ededed" cx="149.39" cy="263" r="2.64" />
              <circle fill="#fff" cx="149.93" cy="262.37" r="1.59" />
            </g>
            <g>
              <circle fill="#ededed" cx="154.39" cy="263.96" r="2.87" />
              <circle fill="#fff" cx="154.82" cy="263.05" r="1.72" />
            </g>
            <g>
              <circle fill="#ededed" cx="160" cy="264.77" r="3.13" />
              <circle fill="#fff" cx="160.53" cy="263.96" r="1.88" />
            </g>
            <g>
              <circle fill="#ededed" cx="178.82" cy="258.62" r="2.33" />
              <circle fill="#fff" cx="179.36" cy="258.02" r="1.4" />
            </g>
            <g>
              <circle fill="#ededed" cx="175.19" cy="261.08" r="2.46" />
              <circle fill="#fff" cx="175.7" cy="260.46" r="1.48" />
            </g>
            <g>
              <circle fill="#ededed" cx="170.61" cy="263" r="2.64" />
              <circle fill="#fff" cx="171.16" cy="262.37" r="1.59" />
            </g>
            <g>
              <circle fill="#ededed" cx="165.61" cy="263.96" r="2.87" />
              <circle fill="#fff" cx="166.04" cy="263.05" r="1.72" />
            </g>
          </g>
          <path
            fill="#d1d1d1"
            opacity=".22"
            d="m127.64,296.65c6.59-2.11,13.72-.92,20.45-.17.46.05.41.76-.05.75-3.4-.06-6.79-.31-10.17-.3-3.4-.1-6.68.5-10.09.46-.41,0-.51-.6-.13-.74h0Z"
          />
          <path
            fill="#fff"
            opacity=".4"
            d="m206.16,277.07c4.4,2.05,3.54,6.41,5.51,9.77,3.15,5.36,3.97,8.97,3.24,10.04-1.2,1.75-12.45-1.89-36.63-1.17-3.59.11-7.72.44-12.08.93l-16.29-8.36c29.46-7.76,52.6-12.91,56.24-11.21Z"
          />
          <path
            fill="#fff"
            opacity=".4"
            d="m111.8,276.71c-4.95,2.52-1.74,4.74-3.82,8.34-3.03,5.23-3.95,10.81-3.24,11.84,1.21,1.75,11.93-1.89,36.38-1.17,19.25.57,53.14,7.45,55.89,10.18,1.08-1.06-.08-3.2-.12-4.81-.08-2.93,1.86-3.64-.65-5.37-41.96-11.35-79.75-21.4-84.44-19.01Z"
          />
          <g>
            <polygon
              fill="#e0eef4"
              points="161.44 273.84 158.63 273.84 156.64 271.29 156.63 267.67 158.6 265.11 161.41 265.1 163.4 267.65 163.41 271.27 161.44 273.84"
            />
            <polygon
              fill="#fbfbfb"
              points="158.57 265.12 159.53 268.1 158.83 268.77 156.66 267.64 158.57 265.12"
            />
            <polygon
              fill="#c0dbe2"
              points="158.48 273.77 159.44 270.79 158.74 270.13 156.57 271.26 158.48 273.77"
            />
            <polygon
              fill="#c0dbe2"
              points="161.43 265.07 160.53 268.07 161.23 268.72 163.39 267.56 161.43 265.07"
            />
            <polygon
              fill="#fbfbfb"
              points="161.52 273.77 160.57 270.79 161.26 270.13 163.43 271.26 161.52 273.77"
            />
            <polygon
              fill="#f6f6f7"
              points="160.86 272.05 159.2 272.05 158.02 270.55 158.02 268.41 159.18 266.9 160.84 266.89 162.02 268.4 162.02 270.53 160.86 272.05"
            />
            <polygon
              fill="#fbfbfb"
              points="160.71 271.6 159.34 271.6 158.37 270.36 158.37 268.59 159.33 267.34 160.7 267.34 161.67 268.58 161.67 270.35 160.71 271.6"
            />
          </g>
          <path
            fill="#d1d1d1"
            opacity=".22"
            d="m191.93,296.04c-9.93-3.52-20.3-7.29-30.71-8.98-.61-.1-.52-1.04.12-.99,10.79.97,21.04,4.92,30.96,9.04.58.24.24,1.15-.36.93h0Z"
          />
          <path
            fill="#d1d1d1"
            opacity=".23"
            d="m104.07,294.46c.54-2.97,2.75-6.06,3.37-7.96.72-2.21,1.2-5.26,1.92-7.47.23-.72,1.26-2.29,2.6-2.78,1.34-.49,3.62-.37,3.2-.21-1.03.4-2.57-.03-4.41,2.27-1.36,1.68-1.6,3.49-1.48,5.67.06,1.12-1.38,5-1.92,5.52-1.7,1.65-2.19,4.1-1.94,6.45.12.08.24.2.35.3.5.46,1.22.54,1.9.56,2.26.08,4.52-.25,6.74-.64.24-.04,1.07-.23.57.22-.28.25-1.22.27-1.59.36-1.13.25-2.23.66-3.38.74-7.03.47-6.02-2.39-5.91-3.03Z"
          />
          <path
            fill="#d1d1d1"
            opacity=".23"
            d="m215.44,294.42c-.73-2.93-3.13-5.87-3.87-7.73-.86-2.16-1.54-5.17-2.4-7.34-.28-.7-1.41-2.2-2.77-2.61-1.37-.41-3.64-.14-3.2,0,1.06.33,2.56-.19,4.55,1.98,1.46,1.59,1.62,3.93,1.64,6.11.01,1.13-.11,2.34.48,3.3.4.64,1.06,1.07,1.63,1.56,1.8,1.54,2.81,3.94,2.71,6.3-.12.09-.22.22-.33.33-.47.49-1.19.62-1.86.68-2.25.22-4.52.04-6.77-.21-.24-.03-1.08-.16-.55.26.29.23,1.24.2,1.61.25,1.14.17,2.27.52,3.42.52,7.04.02,5.86-2.77,5.7-3.4Z"
          />
          <g>
            <g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m164.93,313.02c0-.11.11-.28.24-.37,2.23-1.66,4.73-2.96,7.34-3.93,2.61-.96,5.34-1.61,8.08-1.95.16-.02.29.12.3.3,0,.19-.13.35-.29.37-5.45.61-10.91,2.38-15.44,5.6-.13.09-.23.09-.23-.02Z"
                />
                <path
                  fill="#90ab8a"
                  d="m176.22,307.88c0-.06,0-.11.04-.17.5-1.04.97-2.11,1.39-3.2.07-.17.24-.26.39-.2.15.06.22.25.15.42-.44,1.09-.92,2.15-1.43,3.2-.08.16-.25.24-.39.18-.09-.04-.13-.13-.14-.23Z"
                />
                <path
                  fill="#90ab8a"
                  d="m176.22,307.88c0-.1.04-.21.12-.29.13-.12.31-.12.4,0,.58.8,1.11,1.65,1.59,2.54.08.14.02.34-.11.45-.14.11-.31.09-.38-.05-.48-.88-1-1.71-1.56-2.5-.03-.04-.05-.1-.05-.15Z"
                />
              </g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m180.42,307.12s.62,1.07,1.49,2.2c.88,1.13,2.02,2.35,3.43,2.45,1.42.1,2.88-1,3.96-2.19,1.09-1.18,1.78-2.46,1.78-2.46,0,0-.48-1.41-1.46-2.81-.96-1.4-2.48-2.74-4.03-2.61-1.55.13-2.78,1.57-3.69,2.88-.9,1.32-1.49,2.54-1.49,2.54Z"
                />
                <path
                  fill="#a9bfa4"
                  d="m180.42,307.12c3.56-.43,7.14-.37,10.66,0,0,0-.48-1.41-1.46-2.81-.96-1.4-2.48-2.74-4.03-2.61-1.55.13-2.78,1.57-3.69,2.88-.9,1.32-1.49,2.54-1.49,2.54Z"
                />
              </g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m177.71,305.13s-.69-.95-1.42-2.19c-.72-1.26-1.56-2.77-1.51-4.39.04-1.61,1.13-3.1,2.34-4.11.6-.51,1.22-.9,1.7-1.16.47-.26.79-.38.79-.38,0,0,.35.22.83.64.49.41,1.1,1.03,1.65,1.79,1.11,1.51,1.87,3.59,1.38,5.32-.48,1.73-1.98,2.77-3.29,3.46-1.31.68-2.47,1.02-2.47,1.02Z"
                />
                <path
                  fill="#a9bfa4"
                  d="m177.71,305.13c1.32-3.83,2.13-7.96,1.89-12.24,0,0,.35.22.83.64.49.41,1.1,1.03,1.65,1.79,1.11,1.51,1.87,3.59,1.38,5.32-.48,1.73-1.98,2.77-3.29,3.46-1.31.68-2.47,1.02-2.47,1.02Z"
                />
              </g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m177.84,310.17s-.62,1.17-1.17,2.62c-.55,1.45-1.05,3.16-.68,4.52.38,1.35,1.59,2.17,2.72,2.69,1.13.52,2.18.7,2.18.7,0,0,.83-1.07,1.55-2.55.73-1.48,1.34-3.41.9-4.99-.44-1.58-1.84-2.42-3.11-2.75-1.27-.35-2.4-.24-2.4-.24Z"
                />
                <path
                  fill="#a9bfa4"
                  d="m177.84,310.17c1.49,3.19,2.38,6.81,3.05,10.53,0,0,.83-1.07,1.55-2.55.73-1.48,1.34-3.41.9-4.99-.44-1.58-1.84-2.42-3.11-2.75-1.27-.35-2.4-.24-2.4-.24Z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m167.64,309.78c.08-.07.28-.1.44-.06,2.71.6,5.33,1.65,7.77,3,2.43,1.35,4.7,3,6.75,4.85.12.11.1.3-.04.42-.14.12-.35.13-.47.02-4.02-3.73-8.92-6.71-14.32-8.04-.16-.04-.22-.12-.13-.19Z"
                />
                <path
                  fill="#90ab8a"
                  d="m178.9,314.98s.09-.07.15-.08c1.11-.3,2.23-.64,3.33-1.03.17-.06.35.01.41.16.05.15-.04.33-.22.38-1.12.38-2.23.71-3.36,1-.17.05-.35-.03-.39-.18-.03-.09,0-.18.08-.25Z"
                />
                <path
                  fill="#90ab8a"
                  d="m178.9,314.98c.07-.07.18-.11.3-.1.18.02.29.15.26.3-.23.96-.53,1.91-.88,2.86-.06.15-.24.24-.41.21-.17-.03-.27-.18-.21-.32.35-.93.65-1.87.87-2.81.01-.05.04-.1.08-.14Z"
                />
              </g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m182.21,317.67s-.41,1.16-.7,2.56c-.28,1.41-.46,3.06.38,4.2.85,1.14,2.63,1.53,4.24,1.57,1.61.05,3.03-.25,3.03-.25,0,0,.76-1.28,1.18-2.94.43-1.64.46-3.67-.65-4.76-1.11-1.09-3-1.09-4.58-.92-1.59.18-2.89.53-2.89.53Z"
                />
                <path
                  fill="#a9bfa4"
                  d="m182.21,317.67c2.65,2.41,4.95,5.17,6.96,8.08,0,0,.76-1.28,1.18-2.94.43-1.64.46-3.67-.65-4.76-1.11-1.09-3-1.09-4.58-.92-1.59.18-2.89.53-2.89.53Z"
                />
              </g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m181.96,314.31s.27-1.14.73-2.51c.49-1.37,1.08-2.99,2.34-4.01,1.25-1.02,3.09-1.17,4.65-.91.78.12,1.48.34,1.99.53.5.19.81.35.81.35,0,0,.06.41.05,1.05,0,.64-.06,1.51-.28,2.42-.42,1.83-1.5,3.76-3.13,4.52-1.63.76-3.4.31-4.77-.23-1.37-.55-2.39-1.2-2.39-1.2Z"
                />
                <path
                  fill="#a9bfa4"
                  d="m181.96,314.31c3.76-1.5,7.43-3.58,10.51-6.55,0,0,.06.41.05,1.05,0,.64-.06,1.51-.28,2.42-.42,1.83-1.5,3.76-3.13,4.52-1.63.76-3.4.31-4.77-.23-1.37-.55-2.39-1.2-2.39-1.2Z"
                />
              </g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m178.22,317.7s-1.29.29-2.75.82c-1.46.53-3.09,1.27-3.87,2.44-.78,1.17-.61,2.62-.26,3.82.35,1.19.89,2.11.89,2.11,0,0,1.35-.07,2.95-.49,1.6-.41,3.46-1.21,4.37-2.57.91-1.36.63-2.97.06-4.15-.57-1.19-1.39-1.97-1.39-1.97Z"
                />
                <path
                  fill="#a9bfa4"
                  d="m178.22,317.7c-1.45,3.21-3.61,6.24-5.99,9.18,0,0,1.35-.07,2.95-.49,1.6-.41,3.46-1.21,4.37-2.57.91-1.36.63-2.97.06-4.15-.57-1.19-1.39-1.97-1.39-1.97Z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m152.34,313.92c-.07.08-.25.14-.4.13-2.67-.18-5.33-.82-7.88-1.8-2.54-.98-4.97-2.28-7.23-3.84-.13-.09-.15-.28-.04-.43.11-.15.31-.19.44-.1,4.45,3.14,9.61,5.37,14.95,5.86.15.01.23.09.16.17Z"
                />
                <path
                  fill="#90ab8a"
                  d="m140.79,310.45s-.08.08-.13.11c-1,.48-2,1-2.97,1.57-.15.09-.34.04-.41-.1-.08-.15-.01-.34.14-.42.99-.56,1.99-1.07,3.01-1.54.16-.07.34-.02.4.12.04.09.02.19-.03.27Z"
                />
                <path
                  fill="#90ab8a"
                  d="m140.79,310.45c-.06.08-.15.14-.26.14-.17.01-.3-.11-.3-.26.05-1.01.17-2.02.34-3.04.03-.16.19-.28.35-.27.17,0,.28.14.26.29-.17,1-.29,2-.34,2.98,0,.05-.02.11-.05.15Z"
                />
              </g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m137.19,308.25s.18-1.24.22-2.7c.02-1.47-.09-3.17-1.09-4.19-1-1.02-2.76-1.13-4.29-.92-1.53.2-2.82.74-2.82.74,0,0-.5,1.42-.61,3.16-.13,1.73.2,3.78,1.44,4.71,1.24.93,3.03.62,4.5.2,1.47-.43,2.65-1,2.65-1Z"
                />
                <path
                  fill="#a9bfa4"
                  d="m137.19,308.25c-2.93-2.02-5.58-4.44-7.98-7.07,0,0-.5,1.42-.61,3.16-.13,1.73.2,3.78,1.44,4.71,1.24.93,3.03.62,4.5.2,1.47-.43,2.65-1,2.65-1Z"
                />
              </g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m138.01,311.61s-.06,1.2-.26,2.66c-.22,1.46-.51,3.19-1.52,4.42-1,1.23-2.72,1.67-4.24,1.66-.76,0-1.46-.11-1.97-.22-.51-.11-.82-.22-.82-.22,0,0-.13-.41-.23-1.05-.12-.65-.2-1.54-.16-2.49.08-1.91.77-4.04,2.18-5.07,1.41-1.03,3.16-.85,4.56-.52,1.39.34,2.47.84,2.47.84Z"
                />
                <path
                  fill="#a9bfa4"
                  d="m138.01,311.61c-3.31,2.11-6.41,4.8-8.82,8.29,0,0-.13-.41-.23-1.05-.12-.65-.2-1.54-.16-2.49.08-1.91.77-4.04,2.18-5.07,1.41-1.03,3.16-.85,4.56-.52,1.39.34,2.47.84,2.47.84Z"
                />
              </g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m140.96,307.58s1.17-.5,2.46-1.26c1.29-.77,2.7-1.77,3.24-3.08.54-1.31.12-2.75-.41-3.9-.53-1.15-1.21-1.99-1.21-1.99,0,0-1.27.28-2.71.96-1.44.67-3.07,1.77-3.69,3.29-.63,1.52-.09,3.1.66,4.21.74,1.11,1.65,1.78,1.65,1.78Z"
                />
                <path
                  fill="#a9bfa4"
                  d="m140.96,307.58c.82-3.47,2.34-6.89,4.09-10.24,0,0-1.27.28-2.71.96-1.44.67-3.07,1.77-3.69,3.29-.63,1.52-.09,3.1.66,4.21.74,1.11,1.65,1.78,1.65,1.78Z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m150.15,317.78c-.06-.08-.08-.27-.04-.42.79-2.56,2.02-5,3.55-7.26,1.53-2.25,3.36-4.32,5.39-6.16.12-.11.31-.08.43.06.12.14.11.34,0,.45-4.07,3.61-7.43,8.12-9.13,13.21-.05.15-.14.2-.2.12Z"
                />
                <path
                  fill="#90ab8a"
                  d="m156.18,307.32s-.06-.09-.08-.15c-.24-1.09-.52-2.18-.85-3.26-.05-.17.03-.34.19-.38.16-.04.33.06.38.23.32,1.09.59,2.18.82,3.28.04.17-.06.33-.2.36-.09.02-.19-.02-.25-.09Z"
                />
                <path
                  fill="#90ab8a"
                  d="m156.18,307.32c-.07-.07-.1-.18-.08-.29.03-.17.17-.27.33-.23.97.28,1.93.62,2.88,1.03.15.06.23.25.19.41-.04.16-.2.24-.34.18-.93-.4-1.88-.74-2.83-1.01-.05-.02-.1-.05-.13-.09Z"
                />
              </g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m159.14,304.32s1.17.46,2.58.83c1.42.35,3.11.64,4.32-.1,1.22-.74,1.73-2.43,1.88-3.97.16-1.54-.07-2.92-.07-2.92,0,0-1.26-.81-2.94-1.31-1.65-.52-3.73-.67-4.91.33-1.19.99-1.3,2.81-1.23,4.33.09,1.53.36,2.81.36,2.81Z"
                />
                <path
                  fill="#a9bfa4"
                  d="m159.14,304.32c2.64-2.39,5.6-4.41,8.71-6.15,0,0-1.26-.81-2.94-1.31-1.65-.52-3.73-.67-4.91.33-1.19.99-1.3,2.81-1.23,4.33.09,1.53.36,2.81.36,2.81Z"
                />
              </g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m155.69,304.35s-1.15-.33-2.53-.86c-1.37-.55-2.99-1.23-3.96-2.49-.97-1.26-1-3.03-.64-4.51.18-.74.44-1.4.67-1.87.22-.47.41-.75.41-.75,0,0,.42-.03,1.08.01.66.03,1.54.16,2.46.42,1.85.51,3.76,1.68,4.43,3.29.68,1.61.1,3.27-.54,4.56-.65,1.28-1.38,2.21-1.38,2.21Z"
                />
                <path
                  fill="#a9bfa4"
                  d="m155.69,304.35c-1.3-3.7-3.21-7.34-6.05-10.48,0,0,.42-.03,1.08.01.66.03,1.54.16,2.46.42,1.85.51,3.76,1.68,4.43,3.29.68,1.61.1,3.27-.54,4.56-.65,1.28-1.38,2.21-1.38,2.21Z"
                />
              </g>
              <g>
                <path
                  fill="#90ab8a"
                  d="m158.93,308.15s.22,1.26.67,2.69c.46,1.43,1.11,3.04,2.25,3.86,1.15.82,2.65.75,3.89.5,1.24-.26,2.22-.72,2.22-.72,0,0,.01-1.3-.32-2.86-.32-1.56-1.02-3.39-2.36-4.35-1.34-.96-3-.79-4.25-.32-1.25.47-2.11,1.2-2.11,1.2Z"
                />
                <path
                  fill="#a9bfa4"
                  d="m158.93,308.15c3.2,1.59,6.17,3.86,9.03,6.32,0,0,.01-1.3-.32-2.86-.32-1.56-1.02-3.39-2.36-4.35-1.34-.96-3-.79-4.25-.32-1.25.47-2.11,1.2-2.11,1.2Z"
                />
              </g>
            </g>
            <g>
              <path
                fill="#f9eebc"
                d="m143.54,294.33l3.19,1.05,3.28-.69c2.05-.43,3.82.8,4.27,2.96l.72,3.47,2.18,2.67c1.36,1.67,1.24,3.92-.3,5.42l-2.47,2.42-1.1,3.36c-.69,2.09-2.59,3.12-4.57,2.47l-3.19-1.05-3.28.69c-2.05.43-3.82-.8-4.27-2.96l-.72-3.47-2.18-2.67c-1.36-1.67-1.24-3.92.3-5.42l2.47-2.42,1.1-3.36c.69-2.09,2.59-3.12,4.57-2.47Zm-3.8,15.25c1.64,1.85,3.84,3.21,6.18,4.02,2.34-.6,4.56-1.94,6.41-3.69.7-2.45.72-5.15.23-7.72-1.64-1.85-3.84-3.21-6.18-4.02-2.34.6-4.56,1.94-6.4,3.69-.7,2.45-.72,5.15-.23,7.72Z"
              />
              <rect
                fill="#f9eebc"
                x="138.15"
                y="298.5"
                width="15.2"
                height="15.09"
                rx="2.7"
                ry="2.7"
                transform="translate(459.38 177.44) rotate(93.17)"
              />
              <path
                fill="#fcf8ed"
                d="m144.67,303.94c1.33.22,2.53,1.09,3.17,2.27.05.09.09.18.08.28-.02.13-.13.22-.24.3-1.07.75-2.37,1.16-3.7,1.15-.42-1.07-.38-2.31.11-3.36.14-.3.36-.67.58-.64Z"
              />
              <g>
                <path
                  fill="#fff8e6"
                  d="m140.85,305.19l2.59-2.39c.36-.33,1.24-.04,1,.35-1.36,2.23-1.33,5.2-.43,7.68.16.43-.71.6-1.03.24l-2.31-2.66c-.86-.99-.79-2.32.18-3.21Z"
                />
                <path
                  fill="#fff8e6"
                  d="m147.46,310.72l-3.37-1.05c-.46-.14-.66-1.05-.2-1.04,2.61.06,5.16-1.45,6.87-3.47.29-.35.88.32.72.77l-1.15,3.33c-.43,1.24-1.62,1.84-2.87,1.45Z"
                />
                <path
                  fill="#fff8e6"
                  d="m148.94,302.22l.77,3.44c.11.47-.58,1.09-.8.69-1.25-2.29-3.84-3.75-6.44-4.21-.45-.08-.16-.92.31-1.01l3.46-.67c1.29-.25,2.41.48,2.69,1.76Z"
                />
              </g>
              <g>
                <path
                  fill="#fcf8ed"
                  d="m135.13,305.27l4.07-4.35c.56-.6,2.08-.23,1.72.46-2.01,3.93-1.59,8.91.24,12.98.31.7-1.13,1.1-1.7.53l-4.22-4.2c-1.57-1.56-1.61-3.82-.1-5.43Z"
                />
                <path
                  fill="#fcf8ed"
                  d="m144.97,316.67l-4.35-4.07c-.6-.56-.23-2.08.46-1.72,3.93,2.01,8.91,1.59,12.98-.24.7-.31,1.1,1.13.53,1.7l-4.2,4.22c-1.56,1.57-3.82,1.61-5.43.1Z"
                />
                <path
                  fill="#fcf8ed"
                  d="m156.37,306.82l-4.07,4.35c-.56.6-2.08.23-1.72-.46,2.01-3.93,1.59-8.91-.24-12.98-.31-.7,1.13-1.1,1.7-.53l4.22,4.2c1.57,1.56,1.61,3.82.1,5.43Z"
                />
                <path
                  fill="#fcf8ed"
                  d="m146.53,295.42l4.35,4.07c.6.56.23,2.08-.46,1.72-3.93-2.01-8.91-1.59-12.98.24-.7.31-1.1-1.13-.53-1.7l4.2-4.22c1.56-1.57,3.82-1.61,5.43-.1Z"
                />
              </g>
            </g>
            <g>
              <path
                fill="#f9eebc"
                d="m156.69,305.54l3.19,1.05,3.28-.69c2.05-.43,3.82.8,4.27,2.96l.72,3.47,2.18,2.67c1.36,1.67,1.24,3.92-.3,5.42l-2.47,2.42-1.1,3.36c-.69,2.09-2.59,3.12-4.57,2.47l-3.19-1.05-3.28.69c-2.05.43-3.82-.8-4.27-2.96l-.72-3.47-2.18-2.67c-1.36-1.67-1.24-3.92.3-5.42l2.47-2.42,1.1-3.36c.69-2.09,2.59-3.12,4.57-2.47Zm-3.8,15.25c1.64,1.85,3.84,3.21,6.18,4.02,2.34-.6,4.56-1.94,6.41-3.69.7-2.45.72-5.15.23-7.72-1.64-1.85-3.84-3.21-6.18-4.02-2.34.6-4.56,1.94-6.4,3.69-.7,2.45-.72,5.15-.23,7.72Z"
              />
              <rect
                fill="#f9eebc"
                x="151.29"
                y="309.7"
                width="15.2"
                height="15.09"
                rx="2.7"
                ry="2.7"
                transform="translate(484.44 176.14) rotate(93.17)"
              />
              <path
                fill="#fcf8ed"
                d="m157.81,315.14c1.33.22,2.53,1.09,3.17,2.27.05.09.09.18.08.28-.02.13-.13.22-.24.3-1.07.75-2.37,1.16-3.7,1.15-.42-1.07-.38-2.31.11-3.36.14-.3.36-.67.58-.64Z"
              />
              <g>
                <path
                  fill="#fff8e6"
                  d="m153.99,316.39l2.59-2.39c.36-.33,1.24-.04,1,.35-1.36,2.23-1.33,5.2-.43,7.68.16.43-.71.6-1.03.24l-2.31-2.66c-.86-.99-.79-2.32.18-3.21Z"
                />
                <path
                  fill="#fff8e6"
                  d="m160.6,321.92l-3.37-1.05c-.46-.14-.66-1.05-.2-1.04,2.61.06,5.16-1.45,6.87-3.47.29-.35.88.32.72.77l-1.15,3.33c-.43,1.24-1.62,1.84-2.87,1.45Z"
                />
                <path
                  fill="#fff8e6"
                  d="m162.09,313.43l.77,3.44c.11.47-.58,1.09-.8.69-1.25-2.29-3.84-3.75-6.44-4.21-.45-.08-.16-.92.31-1.01l3.46-.67c1.29-.25,2.41.48,2.69,1.76Z"
                />
              </g>
              <g>
                <path
                  fill="#fcf8ed"
                  d="m148.27,316.47l4.07-4.35c.56-.6,2.08-.23,1.72.46-2.01,3.93-1.59,8.91.24,12.98.31.7-1.13,1.1-1.7.53l-4.22-4.2c-1.57-1.56-1.61-3.82-.1-5.43Z"
                />
                <path
                  fill="#fcf8ed"
                  d="m169.52,318.02l-4.07,4.35c-.56.6-2.08.23-1.72-.46,2.01-3.93,1.59-8.91-.24-12.98-.31-.7,1.13-1.1,1.7-.53l4.22,4.2c1.57,1.56,1.61,3.82.1,5.43Z"
                />
                <path
                  fill="#fcf8ed"
                  d="m159.67,306.62l4.35,4.07c.6.56.23,2.08-.46,1.72-3.93-2.01-8.91-1.59-12.98.24-.7.31-1.1-1.13-.53-1.7l4.2-4.22c1.56-1.57,3.82-1.61,5.43-.1Z"
                />
              </g>
            </g>
            <g>
              <path
                fill="#f9eebc"
                d="m166.79,299.04l2.67-.86,1.88-2.07c1.17-1.29,2.98-1.33,4.34-.1l2.19,1.99,2.79.74c1.74.46,2.76,2.04,2.46,3.82l-.48,2.85.9,2.81c.56,1.75-.22,3.38-1.88,3.91l-2.67.86-1.88,2.07c-1.17,1.29-2.98,1.33-4.34.1l-2.19-1.99-2.79-.74c-1.74-.46-2.76-2.04-2.46-3.82l.48-2.85-.9-2.81c-.56-1.75.22-3.38,1.88-3.91Zm4.91,12.18c2.02.45,4.17.29,6.15-.31,1.29-1.55,2.13-3.55,2.52-5.64-.73-2-2.04-3.84-3.63-5.33-2.02-.45-4.17-.29-6.15.31-1.29,1.55-2.13,3.55-2.52,5.64.73,2,2.04,3.84,3.63,5.33Z"
              />
              <rect
                fill="#f9eebc"
                x="167.68"
                y="299.57"
                width="12.7"
                height="12.61"
                rx="2.25"
                ry="2.25"
                transform="translate(336.93 -6.06) rotate(57.21)"
              />
              <path
                fill="#fcf8ed"
                d="m172.26,304.98c1.01-.5,2.25-.51,3.26-.02.07.04.15.08.19.15.05.1.02.21-.02.32-.36,1.03-1.04,1.95-1.94,2.59-.81-.52-1.39-1.38-1.57-2.32-.05-.27-.09-.63.08-.71Z"
              />
              <g>
                <path
                  fill="#fff8e6"
                  d="m170.29,307.7l.58-2.89c.08-.4.81-.64.85-.25.18,2.18,1.65,4.17,3.48,5.4.32.21-.19.76-.58.67l-2.87-.67c-1.07-.25-1.67-1.19-1.46-2.26Z"
                />
                <path
                  fill="#fff8e6"
                  d="m177.48,308.2l-2.79.94c-.38.13-.96-.39-.64-.61,1.8-1.24,2.78-3.51,2.94-5.72.03-.38.75-.22.87.17l.86,2.82c.32,1.05-.19,2.04-1.23,2.39Z"
                />
                <path
                  fill="#fff8e6"
                  d="m174.31,301.72l2.21,1.95c.3.27.14,1.02-.2.86-1.97-.94-4.43-.65-6.42.31-.34.17-.56-.54-.29-.84l2.01-2.15c.75-.8,1.86-.85,2.69-.13Z"
                />
              </g>
              <g>
                <path
                  fill="#fcf8ed"
                  d="m166.46,310.56l.62-4.94c.08-.68,1.29-1.17,1.39-.53.57,3.64,3.3,6.81,6.53,8.67.56.32-.22,1.3-.89,1.19l-4.92-.77c-1.83-.28-2.96-1.79-2.73-3.63Z"
                />
                <path
                  fill="#fcf8ed"
                  d="m178.71,313.44l-4.94-.62c-.68-.08-1.17-1.29-.53-1.39,3.64-.57,6.81-3.3,8.67-6.53.32-.56,1.3.22,1.19.89l-.77,4.92c-.28,1.83-1.79,2.96-3.63,2.73Z"
                />
                <path
                  fill="#fcf8ed"
                  d="m181.59,301.19l-.62,4.94c-.08.68-1.29,1.17-1.39.53-.57-3.64-3.3-6.81-6.53-8.67-.56-.32.22-1.3.89-1.19l4.92.77c1.83.28,2.96,1.79,2.73,3.63Z"
                />
                <path
                  fill="#fcf8ed"
                  d="m169.34,298.31l4.94.62c.68.08,1.17,1.29.53,1.39-3.64.57-6.81,3.3-8.67,6.53-.32.56-1.3-.22-1.19-.89l.77-4.92c.28-1.83,1.79-2.96,3.63-2.73Z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g id="C-1-3-4_20" v-if="data.clothes.value === 'type-20'">
      <defs>
        <clipPath id="clippath">
          <rect fill="none" width="320" height="320" />
        </clipPath>
      </defs>
      <g fill="none" clip-path="url(#clippath)">
        <g>
          <path
            fill="#2c97c6"
            d="m109.7,280c-5,8.8-9.4,22-11.6,29.4v.1h0v-.1.1h-.1c0,.1-.1.2-.1.3h0c-.1.4-.2.8-.4,1.1-.1.2-.1.3-.2.5v.7c-.5,1.8-.8,2.8-.8,2.8,0,0-.7,1.3,1,3.3.4.6,1,1.2,1.7,1.8h15.4-.2,4.3l16.2-61.6s-17.9,8.7-25.2,21.6Z"
          />
          <path
            fill="#2c97c6"
            d="m223.5,314.9s-.6-2.2-1.6-5.5c-2.2-7.4-6.6-20.5-11.6-29.4-7.3-12.9-25.2-21.6-25.2-21.6l16.2,61.6h4.3-.2,15.4c.7-.6,1.3-1.2,1.7-1.8,1.7-2,1-3.3,1-3.3Z"
          />
          <path
            fill="#38a2da"
            d="m203.1,290c-1.6-17.2-4.7-25.4-20.3-33-.1.3-.3.5-.6.8-1.1,1.6-2.8,3.4-5.3,5.1-4.2,2.9-11.7,3.4-17.8,3.8-5.8.4-7.8.2-16.7-3.8-3-2.1-3.8-4.3-4.3-5.6-.1-.2-.1-.4-.2-.6-16,7.7-21.5,15.6-22.4,33.6l-.9,29.7h90.8l-2.3-30Z"
          />
          <g>
            <path
              fill="#bc1e39"
              d="m171.5,283.2l5.1,5.8c.2.3.7.3.9,0l4.7-5.9c.3-.3.8-.3,1,.1l2.8,5.6c.2.4.7.4.9.1l5.7-5.8c.3-.3.9-.2,1,.3.6,2.3,1.9,8.2,1.7,12-.2,4.8-1.2,10.3-8.7,10.9s-12.9-.2-15.3-3.3c-2.4-3-3.6-7.8-.8-19.5.1-.5.7-.7,1-.3Z"
            />
            <path
              fill="#fff"
              d="m190.3,299.9h-16.4c-.5,0-.8-.4-.8-.8v-3.2c0-.5.4-.8.8-.8h16.4c.5,0,.8.4.8.8v3.2c0,.4-.4.8-.8.8Z"
            />
          </g>
          <path
            fill="#f4d647"
            d="m124.3,265.1l50.8,54.9h-13.9l-44.5-48.8s4.4-4.6,7.6-6.1Z"
          />
          <g>
            <path
              fill="#f7f7f7"
              d="m159.3,261c9.6-.3,12.1-1.1,17.1-5.6,5.1-4.7,18.4,4.2,18.8,8.2.4,4-1.3,5.6-7.2,9.3-6,3.8-16.6,5.9-20.5,4.6-3.8-1.2-8.6-4.4-8.6-14.5.1,0,.1-2,.4-2Z"
            />
            <path
              fill="#f7f7f7"
              d="m159.9,261c-9.6-.3-12.1-1.1-17.1-5.6-5.1-4.7-18.9,4.6-19.3,8.6s3.9,6.7,7.6,8.8c6.1,3.5,16.6,5.9,20.5,4.6,3.8-1.2,8.6-4.4,8.6-14.5,0,.1,0-1.9-.3-1.9Z"
            />
          </g>
          <circle fill="#fff" cx="159.5" cy="280.9" r="3.4" />
          <circle fill="#fff" cx="159.6" cy="292.5" r="3.4" />
        </g>
      </g>
    </g>
    <g id="C-1-3-4_21" v-if="data.clothes.value === 'type-21'">
      <defs>
        <clipPath id="clippath">
          <rect fill="none" width="320" height="320" />
        </clipPath>
      </defs>
      <g fill="none" clip-path="url(#clippath)">
        <g>
          <path
            fill="#bbb"
            d="m133.73,259.3s-17.7,8.6-24.9,21.3c-7.2,12.7-12.4,32.8-12.4,32.8,0,0-1.2,5.2-1.2,6.6h22.4l16.1-60.7Z"
          />
          <path
            fill="#bbb"
            d="m202.25,320h22.4c0-1.4-1.2-6.6-1.2-6.6,0,0-5.2-20.1-12.4-32.8-7.2-12.7-24.9-21.3-24.9-21.3l16.1,60.7Z"
          />
          <path
            fill="#ccc"
            d="m201.59,269.59c-1.91-2.68-7.2-6.06-13.46-8.77l-28.19,12.32-28.19-12.32c-6.26,2.71-11.55,6.09-13.46,8.77-3.56,5-3.14,50.41-3.14,50.41h89.58s.42-45.4-3.14-50.41Z"
          />
          <path
            fill="#bbb"
            d="m196.07,251.19c-4.76-4.86-16.67-3.93-25.43-2.16.23.69.54,1.32.96,1.86.5.63,5.81,4.1,9.71,6.6-.27.13-.53.25-.79.38-7.16,3.47-14.31,7.14-20.51,12.12-6.2-4.98-13.36-8.64-20.51-12.12-.37-.18-.75-.36-1.13-.54,3.54-2.46,8.07-5.74,8.64-6.44.47-.6.8-1.32,1.03-2.12-8.6-1.59-19.58-2.21-24.1,2.41-7.55,7.72-6.4,9.94-5.65,12.89.28,1.12,1.25,2.14,2.46,3.04,1.27-1.03,2.86-2.1,4.67-3.14.74.57,1.65,1.01,2.42,1.43.72.39,1.45.77,2.18,1.15,8.18,4.17,21.45,9.72,29.99,9.72s21.81-5.55,29.99-9.72c.73-.37,1.46-.75,2.18-1.15.75-.4,1.63-.84,2.37-1.39,1.81,1.05,3.4,2.12,4.66,3.15,1.24-.92,2.23-1.95,2.52-3.09.75-2.95,1.9-5.18-5.65-12.89Z"
          />
          <path
            fill="#848484"
            d="m138.3,257.38c3.55-2.47,8.12-5.78,8.7-6.48.2-.26.37-.54.52-.83-5.75-.21-14.18,1.07-13.71,3.58.2,1.06,2.09,2.41,4.49,3.74Z"
          />
          <path
            fill="#848484"
            d="m171.6,250.9c.51.63,5.89,4.14,9.79,6.65,2.54-1.38,4.6-2.8,4.8-3.9.5-2.71-9.4-3.99-15.06-3.49.14.26.29.52.47.75Z"
          />
          <path
            fill="#fff"
            d="m148.93,310.99c-.83,0-1.5-.67-1.5-1.5v-39.67c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5v39.67c0,.83-.67,1.5-1.5,1.5Z"
          />
          <path
            fill="#fff"
            d="m170.95,310.99c-.83,0-1.5-.67-1.5-1.5v-39.67c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5v39.67c0,.83-.67,1.5-1.5,1.5Z"
          />
          <ellipse fill="#fff" cx="148.93" cy="306.36" rx="2.75" ry="3.12" />
          <ellipse fill="#fff" cx="170.95" cy="306.36" rx="2.75" ry="3.12" />
        </g>
      </g>
    </g>
    <g id="C-1-3-4_22" v-if="data.clothes.value === 'type-22'">
      <g fill="none">
        <g>
          <g>
            <path
              fill="#f9c248"
              d="m222.5,318.2c1.7-2,1-3.3,1-3.3,0,0-5.9-22-13.2-34.9s-25.2-21.6-25.2-21.6l16.2,61.6h19.5c.7-.6,1.3-1.2,1.7-1.8Z"
            />
            <path
              fill="#f9c248"
              d="m134.4,259.3s-17.7,8.6-24.9,21.3c-7.2,12.7-13,34.5-13,34.5,0,0-.7,1.2,1,3.2.4.5,1,1.1,1.6,1.7h19.4l15.9-60.7Z"
            />
            <path
              fill="#ffd057"
              d="m203.1,290c-1.6-17.2-4.7-25.4-20.3-33-.1.3-.3.5-.6.8-1.1,1.6-2.2,4.9-4.7,6.6-4.2,2.9-11.9,7.1-18,7.5-5.8.4-13.5-2.7-16.9-7.5-3-2.1-4-5.8-4.5-7.1-.1-.2-.1-.4-.2-.6-16,7.7-21.5,15.6-22.4,33.6l-.9,29.7h90.8l-2.3-30Z"
            />
          </g>
          <path
            fill="#f9c248"
            d="m160,264.94c-7.92,0-14.77-4.15-18.02-10.15-.11-.21-.15-.36-.33-.44s-.34-.02-.45.03l-5.91,2.74c-.09.06-.22.21-.22.39s.05.37.19.65c4.48,8.45,13.88,14.29,24.73,14.29s20.16-5.78,24.66-14.17c.16-.3.16-.47.11-.73s-.22-.43-.36-.51l-5.54-2.57s-.26-.15-.51,0-.31.24-.45.49c-3.28,5.91-10.08,9.98-17.93,9.98Z"
          />
        </g>
      </g>
    </g>
    <g id="C-1-3-4_23" v-if="data.clothes.value === 'type-23'">
      <g fill="none">
        <g>
          <path
            fill="#85b9b9"
            d="m222.5,318.2c1.7-2,1-3.3,1-3.3,0,0-5.9-22-13.2-34.9s-25.2-21.6-25.2-21.6l16.2,61.6h19.5c.7-.6,1.3-1.2,1.7-1.8Z"
          />
          <path
            fill="#85b9b9"
            d="m134.4,259.3s-17.7,8.6-24.9,21.3c-7.2,12.7-13,34.5-13,34.5,0,0-.7,1.2,1,3.2.4.5,1,1.1,1.6,1.7h19.4l15.9-60.7Z"
          />
          <path
            fill="#99d1cf"
            d="m203.1,290c-1.6-17.2-4.7-25.4-20.3-33-.1.3-.3.5-.6.8-1.1,1.6-2.2,4.9-4.7,6.6-4.2,2.9-11.9,7.1-18,7.5-5.8.4-13.5-2.7-16.9-7.5-3-2.1-4-5.8-4.5-7.1-.1-.2-.1-.4-.2-.6-16,7.7-21.5,15.6-22.4,33.6l-.9,29.7h90.8l-2.3-30Z"
          />
          <path
            fill="#85b9b9"
            d="m160,264.94c-7.92,0-14.77-4.15-18.02-10.15-.11-.21-.15-.36-.33-.44s-.34-.02-.45.03l-5.91,2.74c-.09.06-.22.21-.22.39s.05.37.19.65c4.48,8.45,13.88,14.29,24.73,14.29s20.16-5.78,24.66-14.17c.16-.3.16-.47.11-.73s-.22-.43-.36-.51l-5.54-2.57s-.26-.15-.51,0-.31.24-.45.49c-3.28,5.91-10.08,9.98-17.93,9.98Z"
          />
        </g>
      </g>
    </g>
    <g id="C-1-3-4_24" v-if="data.clothes.value === 'type-24'">
      <g fill="none">
        <g>
          <path
            fill="#ea878a"
            d="m222.5,318.2c1.7-2,1-3.3,1-3.3,0,0-5.9-22-13.2-34.9s-25.2-21.6-25.2-21.6l16.2,61.6h19.5c.7-.6,1.3-1.2,1.7-1.8Z"
          />
          <path
            fill="#ea878a"
            d="m134.4,259.3s-17.7,8.6-24.9,21.3c-7.2,12.7-13,34.5-13,34.5,0,0-.7,1.2,1,3.2.4.5,1,1.1,1.6,1.7h19.4l15.9-60.7Z"
          />
          <path
            fill="#ef9ca2"
            d="m203.1,290c-1.6-17.2-4.7-25.4-20.3-33-.1.3-.3.5-.6.8-1.1,1.6-2.2,4.9-4.7,6.6-4.2,2.9-11.9,7.1-18,7.5-5.8.4-13.5-2.7-16.9-7.5-3-2.1-4-5.8-4.5-7.1-.1-.2-.1-.4-.2-.6-16,7.7-21.5,15.6-22.4,33.6l-.9,29.7h90.8l-2.3-30Z"
          />
          <path
            fill="#ea878a"
            d="m160,264.94c-7.92,0-14.77-4.15-18.02-10.15-.11-.21-.15-.36-.33-.44s-.34-.02-.45.03l-5.91,2.74c-.09.06-.22.21-.22.39s.05.37.19.65c4.48,8.45,13.88,14.29,24.73,14.29s20.16-5.78,24.66-14.17c.16-.3.16-.47.11-.73s-.22-.43-.36-.51l-5.54-2.57s-.26-.15-.51,0-.31.24-.45.49c-3.28,5.91-10.08,9.98-17.93,9.98Z"
          />
        </g>
      </g>
    </g>
    <g id="C-1-3-4_25" v-if="data.clothes.value === 'type-25'">
      <g fill="none">
        <g>
          <path
            fill="#1c4f62"
            d="m116.83,262.39s1.22-2.23,3.49-3.22,19.15-5.77,19.15-5.77l19.81,14.58,20.15-14.78,17.18,4.7,6.63,22.02,25.37,39.88v.99l-137.1.47v-1.66l25.33-57.21Z"
          />
          <g>
            <path
              fill="#fff"
              d="m201.19,264.98c-.43-2.04-1.65-1.95-2.63-3.79,0,0-1.1.46-1.2.46,0,0,.71-2,.81-2-2.32-1.97-14.73-6-14.87-6.25-7.2,15.84-38.4,16.76-45.3.3,0,0-8.5,2.8-15.1,5.3h.1c-.36-.02-.41.46-.7.6,0,0,0,.1-.1.1v.1c-4.79,12-6.99,49.69-5.72,59.24,10.18,0,79.41.11,88.43.11,1.41-12.27-2.73-40.72-3.73-54.17Z"
            />
            <g>
              <g>
                <path
                  fill="#184756"
                  d="m94.1,309c.24-.81.49-1.62.74-2.42.56-1.81,1.15-3.62,1.76-5.41.69-2.02,1.4-4.04,2.15-6.04s1.61-4.17,2.48-6.23,1.75-4.02,2.73-5.98c.55-1.12,1.13-2.22,1.74-3.31,7.3-12.9,8.8-11.8,8.8-11.8l.2,51.8h-4.1s-19.1,0-19.1,0c.44-2.19.9-4.37,1.46-6.53.35-1.36.74-2.72,1.14-4.07Z"
                />
                <path
                  fill="#184756"
                  d="m94.2,308.87c3.64-11.98,7.92-24.02,13.9-35.07v-.1c2.81-5.38,7.72-13.1,13.2-14.9-.61.97-.75,2.12-1.2,3.1-4.49,19.08-4.27,38.75-5,58.3h-15.1c-.88-.57-1.86-1.31-2.6-2.1-3.84-3.09-3.84-4.57-3.2-9.23Z"
                />
              </g>
              <g>
                <path
                  fill="#184756"
                  d="m225.9,309.2c-2.2-7.4-6.6-20.5-11.6-29.4-7.3-12.9-8.8-11.8-8.8-11.8l-.2,51.8h23.3c-1.1-5-1.7-7.2-2.7-10.6Z"
                />
                <path
                  fill="#184756"
                  d="m226.51,311.86c-3.48-12.96-8.3-25.95-14.61-37.86v-.1c-2.81-5.38-7.64-13.33-13.12-15.13.61.97.67,2.34,1.12,3.33,4.49,19.08,4.27,38.75,5,58.3h15.1c.88-.57,1.86-1.31,2.6-2.1,2.05-1.48,3.73-3.83,3.91-6.44Z"
                />
              </g>
              <path
                fill="#d6ecf7"
                d="m186.4,257.2c-.7-.4-1.4-.8-2.1-1.1l-24.6,35.5-26.6-34.3c-.2.1-.3.2-.5.3-.4,5.1-.9,32.7-1.3,60.5h57l-1.9-60.9Z"
              />
              <g>
                <polygon
                  fill="#861c21"
                  points="166.7 266.4 153.1 266.4 156.6 277.3 156.6 277.4 163 277.4 166.7 266.4"
                />
                <polygon
                  fill="#a91119"
                  points="175.1 315.6 163 277.4 163 277.4 156.6 277.4 144.8 315.6 175.1 315.6"
                />
              </g>
              <g>
                <path
                  fill="#edeced"
                  d="m141.6,251.8l-18.5,6.5,21.7,27.2,15.8-19.7c.1.1-7-2.4-19-14Z"
                />
                <path
                  fill="#edeced"
                  d="m177.8,251.6l18.8,6.3-18.5,27.7-19.6-20.2c0,.1,7.3-2.3,19.3-13.8Z"
                />
              </g>
              <g>
                <path
                  fill="#1c4f62"
                  d="m204.9,304.8h0c-.02-1.38-.13-2.26-.1-3.4h0c.06-3.97-.05-8.03-.6-12h0c-.38-4.85-1.09-9.83-1.7-14.7h0c-.96-5.51-1.33-10.89-3.6-15.9h-.1.1c-1.5-1.41-4.87-1.96-8.6-3.4-.92,10.91-24.4,44.13-30.3,53.4-6-9.31-26.99-43.68-34.7-50.8.51-.35,1.86-1.38,2.4-1.7-1.75.68-4.33,1.49-5.61,2.1-.46.06-.58.56-.89.8,0,0,0,.1-.1.1-.01.16-.12.36-.2.6h0c-.75,2.15-1.43,4.32-1.8,6.6h0c-.51,2.44-1.01,4.92-1.5,7.6h0c-.37,2.26-.61,4.44-1.1,6.7h0c-.44,2.62-.81,5.25-1.1,7.8h.1c-.33,2.08-.42,4.37-.7,6.4h0c-.14,1.77-.18,3.51-.2,5.2h0c0,.71-.31,19.59-.31,19.89l90.98.3s-.37-13.28-.37-15.6Z"
                />
                <path
                  fill="#134152"
                  d="m125.3,257.3v12.4h9.7l-9,9.5,34,29.7-26-54.6c-1.8.5-8.7,3-8.7,3Z"
                />
                <path
                  fill="#134152"
                  d="m194.3,279.3l-9-9.5,9.7.1-.8-13.2-4-1.3c-1.3-.4-2.6-.8-3.8-1.2l-26.6,54.6,34.5-29.5Z"
                />
              </g>
              <g>
                <polygon
                  fill="#134152"
                  points="160.4 320.17 159.4 320.17 159.4 308 159.9 308.82 160.4 308.21 160.4 320.17"
                />
                <circle fill="#a97b26" cx="159.9" cy="313.5" r="2.1" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g id="C-1-3-4_26" v-if="data.clothes.value === 'type-26'">
      <g fill="none">
        <g>
          <path
            fill="#184756"
            d="m98.2,309.4c2.2-7.4,6.6-20.5,11.6-29.4,7.3-12.9,25.2-21.6,25.2-21.6l-16.2,63.1h-23.2c1-5.1,1.6-8.8,2.6-12.1Z"
          />
          <path
            fill="#184756"
            d="m221.8,309.4c-2.2-7.4-6.6-20.5-11.6-29.4-7.3-12.9-25.2-21.6-25.2-21.6l16.2,63.1h23.3c-1.1-5.1-1.7-8.8-2.7-12.1Z"
          />
          <path
            fill="#f4f4f4"
            d="m201.86,290c-1.6-17.2-3.66-25.2-19.26-32.8-.1.3-.2.3-.5.6-14.6,13.8-38,5.8-44.1-.5-.1-.2-.1-.4-.2-.6-16,7.7-20.38,15.6-21.28,33.6l-.9,31.2h88.54l-2.3-31.5Z"
          />
          <path
            fill="#c4b898"
            d="m186.4,259.2c-.7-.4-1.4-.8-2.1-1.1l-24.6,35.5-26.6-34.3c-.2.1-.3.2-.5.3-.4,5.1-.9,34.2-1.3,62h57l-1.9-62.4Z"
          />
          <path
            fill="#eeedee"
            d="m144,253l-14.9,8.7,17.7,19.9,12.5-17.3c-.1,0-5.2-1.5-15.3-11.3Z"
          />
          <path
            fill="#eeedee"
            d="m174.6,252.8l14.9,8.1-16.5,20.1-16.6-17.1s8.1-1.3,18.2-11.1Z"
          />
          <path
            fill="#1c4f62"
            d="m203,290c-1.2-12.4-3.1-20.1-9.9-26.3-2.4-2.2-3.4-3.1-7.1-5l-26.4,51.6-25.2-51.6c-3.5,1.8-5.1,2.7-7.6,4.7-7.7,6.2-10.7,13.9-11.4,26.9l-.9,31.2h90.7l-2.2-31.5Z"
          />
          <g>
            <path
              fill="#134152"
              d="m134.8,258.2l-1.8.9c-1.1.5-3.8,2.2-4.2,2.5l-1.7,1.2v10.9h9.1l-8.4,8.9,31.8,27.8-24.8-52.2Z"
            />
            <polygon
              fill="#134152"
              points="185 258 191.8 263.1 192.5 273.8 183.4 273.8 191.8 282.7 159.6 310.3 185 258"
            />
          </g>
          <polygon
            fill="#134152"
            points="160.1 321.5 159.1 321.5 159.1 309.8 159.6 310.5 160.1 309.7 160.1 321.5"
          />
          <circle fill="#aa7b26" cx="159.6" cy="315" r="2.1" />
          <g>
            <path
              fill="#871c21"
              d="m158.1,268.4l-5.3,17.9s-6.8-2.1-12.5-5.8l10.9-12.5,6.9.4Z"
            />
            <path
              fill="#94181f"
              d="m156.6,263.3l-16-5s-3.5,9.6.8,17.2l13.6-5.1,1.6-7.1Z"
            />
            <path
              fill="#871c21"
              d="m160.2,268.4l5.3,17.9s7-2.7,12.7-6.4l-11-11.9-7,.4Z"
            />
            <path
              fill="#94181f"
              d="m161,263.5l16.6-5.1s3.5,9.6-.8,17.2l-13.6-5.1-2.2-7Z"
            />
            <polygon
              fill="#aa1119"
              points="163.3 262.7 163.1 270.7 154.2 271.1 154.5 262.5 163.3 262.7"
            />
          </g>
        </g>
      </g>
    </g>
    <g id="C-1-3-4_27" v-if="data.clothes.value === 'type-27'">
      <g fill="none">
        <g>
          <g>
            <g>
              <g>
                <path
                  fill="#f4f4f4"
                  d="m226.84,311.5c-1.57-5.11-3.25-10.37-5.1-15.5-3.37-9.27-7.18-18.39-12.3-26.8-.3-.5-.6-.9-.9-1.4-2.42-3.59-6.32-7.9-9.6-8.8h0c6.83,18.62,3.97,44.94,6.3,61.47,3.81-.25,14.39,1.04,14.96-.47,2.24-1.97,6.65-8.4,6.65-8.5Z"
                />
                <path
                  fill="#4273ba"
                  d="m220.54,320.3c2.5-2.07,6.41-5.09,6.3-8.71.05-.8-.36-1.75-.7-2.5,0,0-19.94,11.08-19.94,11.08l14.35.13Z"
                />
              </g>
              <path
                fill="#fff"
                d="m205.04,316c0-.9-.1-1.7-.1-2.5v-1.9c-.31-7.48.09-14.79-.7-22.2-.21-2.23-.38-4.38-.6-6.7-.56-4.77-1.19-9.99-2.1-14.6-.63-3.15-.97-6.28-2.4-9.1h-.1.1c-3.04-2.26-11.57-4.38-16.4-6,.02.58-.27,1.33-.9,2.5-1.1,1.5-2.53,3.83-5.03,5.43-4.2,2.8-9.08,4.73-16.57,4.73-.51,0-1.01-.01-1.5-.03v55.69c23.01,0,46.5-.84,46.5-.84,0,0-.21-3.24-.2-4.47Z"
              />
              <path
                fill="#4273ba"
                d="m178.34,249.9c-1.8-.9-2.1.9-3.4,2.4-3.8,4.2-10,5.5-14.8,5.6-.45,0-.92.13-1.4.1v7.63c.49.02.99.03,1.5.03,7.5,0,12.37-1.93,16.57-4.73,2.5-1.6,3.93-3.93,5.03-5.43.63-1.17.92-1.92.9-2.5,0-.07.01-.14,0-.2-.2-1.2-1.9-1.7-4.4-2.9Z"
              />
            </g>
            <g>
              <g>
                <path
                  fill="#f4f4f4"
                  d="m93.16,311.5c1.57-5.11,3.25-10.37,5.1-15.5,3.37-9.27,7.18-18.39,12.3-26.8.3-.5.6-.9.9-1.4,2.42-3.59,6.32-7.9,9.6-8.8h0c-6.83,18.62-3.97,44.94-6.3,61.47-3.81-.25-14.39,1.04-14.96-.47-2.24-1.97-6.65-8.4-6.65-8.5Z"
                />
                <path
                  fill="#4273ba"
                  d="m99.46,320.3c-2.5-2.07-6.41-5.09-6.3-8.71-.05-.8.36-1.75.7-2.5,0,0,19.94,11.08,19.94,11.08l-14.35.13Z"
                />
              </g>
              <path
                fill="#fff"
                d="m114.96,316c0-.9.1-1.7.1-2.5v-1.9c.31-7.48-.09-14.79.7-22.2.21-2.23.38-4.38.6-6.7.56-4.77,1.19-9.99,2.1-14.6.63-3.15.97-6.28,2.4-9.1h.1-.1c3.04-2.26,11.57-4.38,16.4-6-.02.58.27,1.33.9,2.5,1.1,1.5,2.53,3.83,5.03,5.43,4.2,2.8,9.08,4.73,16.57,4.73.51,0,1.01-.01,1.5-.03v55.69c-23.01,0-46.5-.84-46.5-.84,0,0,.21-3.24.2-4.47Z"
              />
              <path
                fill="#4273ba"
                d="m141.66,249.9c1.8-.9,2.1.9,3.4,2.4,3.8,4.2,10,5.5,14.8,5.6.45,0,.87.25,1.35.21l.05,7.24v.27c-.49.02-.99.03-1.5.03-7.5,0-12.37-1.93-16.57-4.73-2.5-1.6-3.93-3.93-5.03-5.43-.63-1.17-.92-1.92-.9-2.5,0-.07-.01-.14,0-.2.2-1.2,1.9-1.7,4.4-2.9Z"
              />
            </g>
          </g>
          <g>
            <path
              fill="#fff"
              d="m187.4,290.1h-13.4c-.7,0-1.2-.5-1.2-1.2v-6.7c0-.7.5-1.2,1.2-1.2h13.4c.7,0,1.2.5,1.2,1.2v6.7c0,.7-.5,1.2-1.2,1.2Z"
            />
            <path
              fill="#ccc"
              d="m187.4,290.35h-13.4c-.84,0-1.45-.61-1.45-1.45v-6.7c0-.84.61-1.45,1.45-1.45h13.4c.84,0,1.45.61,1.45,1.45v6.7c0,.84-.61,1.45-1.45,1.45Zm-13.4-9.1c-.56,0-.95.39-.95.95v6.7c0,.56.39.95.95.95h13.4c.56,0,.95-.39.95-.95v-6.7c0-.56-.39-.95-.95-.95h-13.4Z"
            />
          </g>
        </g>
      </g>
    </g>
    <g id="C-1-3-4_28" v-if="data.clothes.value === 'type-28'">
      <g fill="none">
        <g>
          <g>
            <path
              fill="#f4f4f4"
              d="m98.1,309.4c2.2-7.4,6.6-20.5,11.6-29.4,7.3-12.9,25.2-21.6,25.2-21.6l-16.2,61.6h-4.1c-12.2-2.1-15.6-7.5-16.5-10.6Z"
            />
            <path
              fill="#4273ba"
              d="m117.5,320l-19.4-10.5v-.1.1h-.1c0,.1-.1.2-.1.3h0c-.1.4-.2.8-.4,1.1-.1.2-.1.3-.2.5v.7c-.5,1.8-.8,2.8-.8,2.8,0,0-.7,1.3,1,3.3.4.6,1,1.2,1.7,1.8h15.4-.2,3.1Z"
            />
          </g>
          <g>
            <path
              fill="#f4f4f4"
              d="m221.9,309.4c-2.2-7.4-6.6-20.5-11.6-29.4-7.3-12.9-25.2-21.6-25.2-21.6l16.2,61.6h4.1c12.2-2.1,15.6-7.5,16.5-10.6Z"
            />
            <path
              fill="#4273ba"
              d="m223.5,314.9s-.6-2.2-1.6-5.5v.1-.1l-19.6,10.6h3.3-.2,15.4c.7-.6,1.3-1.2,1.7-1.8,1.7-2,1-3.3,1-3.3Z"
            />
          </g>
          <path
            fill="#fff"
            d="m203.1,290c-1.6-17.2-4.7-25.4-20.3-33-.1.3-.3.5-.6.8-1.1,1.6-2.2,4.9-4.7,6.6-4.2,2.9-11.9,7.1-18,7.5-5.8.4-13.5-2.7-16.9-7.5-3-2.1-4-5.8-4.5-7.1-.1-.2-.1-.4-.2-.6-16,7.7-21.5,15.6-22.4,33.6l-.9,29.7h90.8l-2.3-30Z"
          />
          <path
            fill="#4273ba"
            d="m182.9,257.4c-.2-1.2-2-1.7-4.5-2.9-1.5-.7-2.7,3.4-4.4,5.4-3.8,5.3-9.1,7.8-14.1,7.9-3.7,0-6.9-.1-11.1-3.5-2.9-2.3-4.7-5.3-6.2-8.7-.4-.9-.9-1.5-1.7-1.1-2.6,1.2-4.5,1.8-4.9,2.9-.2.6.2,1.5.6,2.6.5,1.2,2.4,4.6,5.4,8.2.3.4.6.7,1,1,7,5.3,9.5,5,16.8,5.2,8-.5,11.5-2.5,15.5-5.5.3-.2.6-.5.9-.8,3.2-3.4,5-6.2,5.8-8,.7-1.3,1-2.1.9-2.7h0Z"
          />
          <g>
            <path
              fill="#fff"
              d="m187.5,290.1h-13.4c-.7,0-1.2-.5-1.2-1.2v-6.7c0-.7.5-1.2,1.2-1.2h13.4c.7,0,1.2.5,1.2,1.2v6.7c0,.7-.5,1.2-1.2,1.2Z"
            />
            <path
              fill="#ccc"
              d="m187.5,290.35h-13.4c-.84,0-1.45-.61-1.45-1.45v-6.7c0-.84.61-1.45,1.45-1.45h13.4c.84,0,1.45.61,1.45,1.45v6.7c0,.84-.61,1.45-1.45,1.45Zm-13.4-9.1c-.56,0-.95.39-.95.95v6.7c0,.56.39.95.95.95h13.4c.56,0,.95-.39.95-.95v-6.7c0-.56-.39-.95-.95-.95h-13.4Z"
            />
          </g>
        </g>
      </g>
    </g>
    <g id="C-1-3-4_29" v-if="data.clothes.value === 'type-29'">
      <g fill="none">
        <g>
          <g>
            <path
              fill="#4b5c63"
              d="m135.55,255.64s-15.58,6.02-15.59,5.98v-.03c-3.19,1-5.75,3.71-7.85,6.29h-.01c-.66.83-1.33,1.76-1.96,2.68h.02c-8.55,13.44-17.66,34.42-21.05,49.95-.76,3.47,6.42,0,9.04,2.04,0,0,14.24,0,14.24,0,0,0,0-.02,0-.03l12.59,1.95s-.05-36.71,10.57-68.83Z"
            />
            <path
              fill="#4b5c63"
              d="m182.32,255.64s15.58,6.02,15.59,5.98v-.03c3.19,1,5.75,3.71,7.85,6.29h.01c.66.83,1.33,1.76,1.96,2.68h-.02c8.55,13.44,17.66,34.42,21.05,49.95.76,3.47-6.42,0-9.04,2.04,0,0-14.24,0-14.24,0,0,0,0-.02,0-.03l-12.59,1.95s.05-36.71-10.57-68.83Z"
            />
          </g>
          <path
            fill="#556770"
            d="m205.48,322.89c.07-12.18-.6-24.53-2.32-36.69-.6-4.24-1.32-8.4-2.04-12.62-.36-2.12-.8-4.22-1.38-6.29-.36-1.29-1.19-5.59-2.57-6.75s-5.75-2.25-7.11-2.74c-2.59-.92-5.2-1.84-7.84-2.65-.13-.04-.26-.08-.38-.12.11.63-.19,2.25-1.06,3.44-1.11,1.52-15.39,19.68-21.47,20.06-5.83.36-22.05-19.25-22.53-20.51-.42-1.1-.51-2.44-.32-2.99-.3.1-.61.21-.92.32-2.69.94-5.41,1.8-8.06,2.86-1.71.68-3.5,1.25-5.07,2.24-1.84,1.16-2.36,3.32-3.04,5.31-.55,1.62-.98,3.28-1.34,4.95-.69,3.25-1.11,6.55-1.64,9.83-2.27,14.02-2.54,28.23-3.21,42.39,4.76.13,9.53.02,14.29.02h67.85c2.99,0,5.98,0,8.99,0v-.08l1.89-.03-.74.05Z"
          />
          <path
            fill="#4b5c63"
            opacity=".45"
            d="m118.05,270.73c.36-1.67.79-3.33,1.34-4.95.59-1.73,1.06-3.59,2.39-4.81-1.11.42-1.82.69-1.82.68v-.03c-3.19,1-5.75,3.71-7.85,6.29h-.01c-.66.83-1.33,1.76-1.96,2.68h.02c-8.55,13.44-17.66,34.42-21.05,49.95-.76,3.47,6.42,0,9.04,2.04,0,0,14.24,0,14.24,0,0,0,0-.02,0-.03l.82.13c.66-14.06.94-28.19,3.2-42.11.53-3.28.94-6.58,1.64-9.83Z"
          />
          <path
            fill="#38474f"
            opacity=".6"
            d="m110.19,329.69c.24-9,1.31-31.19,6.08-50.07,0,0-3.38,31.08-2.77,49.78l-3.32.28Z"
          />
          <path
            fill="#38474f"
            opacity=".6"
            d="m208.05,329.7c-.24-9-1.31-31.19-6.08-50.07,0,0,3.38,31.08,2.77,49.78l3.32.28Z"
          />
          <path
            fill="#fff"
            opacity=".24"
            d="m225.84,317.25v-2.08h1.6c-.1-.35-.19-.7-.29-1.06h-1.3v-4.26c-.34-1.05-.69-2.11-1.06-3.18v7.44h-8.28l6.75-11.69c-.16-.43-.32-.86-.48-1.29l-7.19,12.45-4.14-7.17,1.8-1.04h0s9.12-5.27,9.12-5.27c-.13-.33-.26-.67-.39-1l-11.06,6.39-4.14-7.17h14.89c-.14-.35-.29-.71-.44-1.06h-14.45l4.14-7.17,9.65,5.57c-.23-.54-.46-1.08-.69-1.63l-6.64-3.83h0s-1.8-1.04-1.8-1.04l3.41-5.91c-.19-.38-.38-.76-.57-1.14l-3.76,6.52-12.42-7.17h15.84c-.19-.36-.37-.71-.56-1.06h-15.28l11.56-6.68c-.18-.31-.36-.61-.54-.91l-.93.54h0s-10.62,6.13-10.62,6.13l7.31-12.67c-.24-.28-.49-.56-.74-.84l-7.49,12.97v-14.34h6.12c-.4-.37-.82-.73-1.25-1.06h-4.87v-3.41c-.31-.18-.66-.35-1.06-.52v3.94h-8.28l3.25-5.63c-.18-.06-.35-.11-.48-.16-.18-.06-.37-.13-.55-.19l-3.15,5.45-4.14-7.17.82-.47c-.27-.09-.54-.18-.82-.27-.13-.04-.26-.08-.38-.12.06.37-.02,1.09-.27,1.85l3.87,6.7h-8.8c-.29.35-.59.7-.91,1.06h9.7l-4.14,7.17-7.88-4.55c-.24.27-.48.54-.73.81l6.28,3.62h0s1.8,1.04,1.8,1.04l-4.14,7.17-5.73-9.92c-.26.27-.51.53-.77.79l5.58,9.66h-8.28v-7.04c-.36.33-.71.65-1.06.95v6.08h-8.28l1.11-1.92c-.35,0-.72-.05-1.13-.17l-.9,1.55-1.58-2.74c-.65-.4-1.33-.88-2.04-1.42l2.7,4.68h-16.56l11.49-6.63c-.28-.24-.56-.49-.84-.75l-.56.32h0s-10.62,6.13-10.62,6.13l6.42-11.12c-.26-.27-.51-.54-.76-.81l-6.58,11.4v-14.34h3.9c-.32-.36-.63-.72-.93-1.06h-2.97v-3.56c-.45-.57-.81-1.04-1.06-1.39v4.95h-8.28l4.29-7.43c-.51.17-1.02.35-1.53.52l-3.68,6.38-2.38-4.12c-.33.13-.67.26-.99.4l2.45,4.25h-10.72c-.43.33-.85.69-1.25,1.06h11.97l-4.14,7.17-9.49-5.48c-.24.27-.48.54-.71.82l7.87,4.54h0s1.8,1.04,1.8,1.04l-4.14,7.17-6.6-11.43c-.23.31-.46.61-.69.93l6.37,11.03h-8.28v-8.09c-.35.58-.71,1.17-1.06,1.77v6.31h-3.51c-.19.35-.37.7-.56,1.06h4.07v14.34l-6.03-10.44c-.19.38-.37.77-.56,1.16l5.66,9.81-8.05-4.65c-.15.33-.28.65-.43.98l7.95,4.59h-9.9c-.15.35-.29.71-.44,1.06h10.33l-12.42,7.17-.39-.67c-.32.89-.62,1.78-.92,2.66l.92-.53,4.14,7.17h-7.15c-.1.36-.2.71-.29,1.06h7.44l-3.89,6.74c.42-.03.85-.05,1.26-.06l3.55-6.15,3.94,6.83h1.23l-4.25-7.37h8.28v7.37h1.06v-7.37h8.28l-4.29,7.44.16.03c0,.08,0,.17-.01.25.3,0,.61,0,.91.01l4.15-7.19,4.14,7.17-.1.06c.72,0,1.43,0,2.15-.01l1.2-.69h0s10.62-6.13,10.62-6.13l-3.93,6.81h1.23l3.63-6.28v6.28h1.06v-6.28l3.63,6.28h1.23l-3.93-6.81,10.62,6.13h0s1.18.68,1.18.68h2.13l-.06-.03,4.14-7.17,4.16,7.2h1.23l-4.47-7.74h8.28v7.74h1.06v-7.74h8.28l-4.47,7.74h1.23l4.16-7.2,4.14,7.17-.06.03h2.13l1.18-.68h0s10.62-6.13,10.62-6.13l-3.93,6.81h1.23l3.63-6.28v6.28h1.06v-6.28l3.63,6.28h1.23l-3.93-6.81,10.62,6.13h0s.54.31.54.31h2.9l3.95-6.83,3.94,6.83h.2c.23-.18.5-.3.79-.4l-4.02-6.96h8.28v6.81c.37.03.72.07,1.06.09v-4.83Zm-127.04-3.67l-4.14-7.17,1.8-1.04h0s10.62-6.13,10.62-6.13l-8.28,14.34Zm9.2-1.54v2.08h-8.28l8.28-14.34v12.26Zm19.99-46.9l8.28,14.34-10.62-6.13h0s-1.8-1.04-1.8-1.04l4.14-7.17Zm-17.48,32.12l12.42-7.17,4.14,7.17h-16.56Zm16.56,1.06l-4.14,7.17-12.42-7.17h16.56Zm-3.22-8.76l1.8-1.04h0s10.62-6.13,10.62-6.13l-8.28,14.34-4.14-7.17Zm-.53-16.32l12.42,7.17h-16.56l4.14-7.17Zm12.42,8.23l-12.42,7.17-4.14-7.17h16.56Zm-17.48.53l4.14,7.17-1.8,1.04h0s-10.62,6.13-10.62,6.13l8.28-14.34Zm-9.2,1.54v-2.08h8.28l-8.28,14.34v-12.26Zm0,30.57v-14.34l8.28,14.34h-8.28Zm.92-14.87l10.62,6.13h0s1.8,1.04,1.8,1.04l-4.14,7.17-8.28-14.34Zm13.34,23.1l-4.14-7.17h16.56l-12.42,7.17Zm-4.14-8.23l4.14-7.17,12.42,7.17h-16.56Zm6.47-7.05h0s-1.8-1.04-1.8-1.04l4.14-7.17,8.28,14.34-10.62-6.13Zm11.54-6.66v12.26l-8.28-14.34h8.28v2.08Zm0-5.22v2.08h-8.28l8.28-14.34v12.26Zm0-28.5v12.26l-8.28-14.34h8.28v2.08Zm19.99,15.31l8.28,14.34-10.62-6.13h0s-1.8-1.04-1.8-1.04l4.14-7.17Zm-8.81,15.26l4.14-7.17,12.42,7.17h-16.56Zm16.56,1.06l-12.42,7.17-4.14-7.17h16.56Zm-8.67-16.85l-4.14,7.17-12.42-7.17h16.56Zm-6.47,7.05h0s1.8,1.04,1.8,1.04l-4.14,7.17-8.28-14.34,10.62,6.13Zm-11.54,6.66v-12.26l8.28,14.34h-8.28v-2.08Zm0,17.48v-14.34h8.28l-8.28,14.34Zm9.2-13.81l4.14,7.17-1.8,1.04h0s-10.62,6.13-10.62,6.13l8.28-14.34Zm4.67,23.49l-12.42-7.17h16.56l-4.14,7.17Zm-12.42-8.23l12.42-7.17,4.14,7.17h-16.56Zm17.48-.53l-4.14-7.17,1.8-1.04h0s10.62-6.13,10.62-6.13l-8.28,14.34Zm9.2-1.54v2.08h-8.28l8.28-14.34v12.26Zm0-28.5v12.26l-8.28-14.34h8.28v2.08Zm19.99-18.4l8.28,14.34-10.62-6.13h0s-1.8-1.04-1.8-1.04l4.14-7.17Zm-17.48,32.12l12.42-7.17,4.14,7.17h-16.56Zm16.56,1.06l-4.14,7.17-12.42-7.17h16.56Zm-3.22-8.76l1.8-1.04h0s10.62-6.13,10.62-6.13l-8.28,14.34-4.14-7.17Zm-.53-16.32l12.42,7.17h-16.56l4.14-7.17Zm12.42,8.23l-12.42,7.17-4.14-7.17h16.56Zm-17.48.53l4.14,7.17-1.8,1.04h0s-10.62,6.13-10.62,6.13l8.28-14.34Zm-9.2,1.54v-2.08h8.28l-8.28,14.34v-12.26Zm0,30.57v-14.34l8.28,14.34h-8.28Zm.92-14.87l10.62,6.13h0s1.8,1.04,1.8,1.04l-4.14,7.17-8.28-14.34Zm13.34,23.1l-4.14-7.17h16.56l-12.42,7.17Zm-4.14-8.23l4.14-7.17,12.42,7.17h-16.56Zm6.47-7.05h0s-1.8-1.04-1.8-1.04l4.14-7.17,8.28,14.34-10.62-6.13Zm11.54-6.66v12.26l-8.28-14.34h8.28v2.08Zm0-5.22v2.08h-8.28l8.28-14.34v12.26Zm0-28.5v12.26l-8.28-14.34h8.28v2.08Zm12.6,21.83h0s1.8,1.04,1.8,1.04l-4.14,7.17-8.28-14.34,10.62,6.13Zm-11.54,6.66v-12.26l8.28,14.34h-8.28v-2.08Zm0,17.48v-14.34h8.28l-8.28,14.34Zm9.2-13.81l4.14,7.17-1.8,1.04h0s-10.62,6.13-10.62,6.13l8.28-14.34Zm4.67,23.49l-6.4-3.7c.02.38.04.77.05,1.15-.02-.39-.04-.77-.05-1.15l-6.02-3.47h16.56l-4.14,7.17Zm-6.58-8.23c.01.3.02.6.03.9-.01-.3-.02-.6-.03-.9h-5.84l12.42-7.17,4.14,7.17h-10.72Z"
          />
          <path
            fill="#38474f"
            d="m143.22,252.28l19.38,26.58-9.76,9.52-22.71-31.26c7.68-4.45,13.09-4.85,13.09-4.85Z"
          />
          <path
            fill="#38474f"
            d="m175.79,252.28l-46.74,67.84h18.42l41.08-61.94c-7.23-4.88-12.75-5.9-12.75-5.9Z"
          />
        </g>
      </g>
    </g>
    <g id="C-1-3-4_30" v-if="data.clothes.value === 'type-30'">
      <defs>
        <clipPath id="clippath">
          <path
            fill="#cbf4ff"
            d="m92.46,320s9.12-28.22,14.13-38.23c7.79-15.53,18.76-24.74,33.1-28.87l20.3,27,23.32-24.8c12.41,5.33,22.97,14.82,30.3,27.07,6.46,10.79,13.92,37.83,13.92,37.83H92.46Z"
          />
        </clipPath>
        <clipPath id="clippath-1">
          <path
            fill="none"
            d="m192.27,259.17c.8-1.25,2.25-2.02,3.68-2.42,1.9-.54,3.92-.02,5.83.48,2.53.67,5.08,1.33,7.41,2.52s3.34,2.37,4.41,4.76c1.35,2.99-.87,13.47-1.38,14.71-.62,1.52-2.35,2.73-3.99,2.85-2.51.18-5.05.95-7.47,1.93-2.4.97-5.22-.56-7.4-1.96-2.02-1.3-2.73-3.62-3.84-5.75-1.45-2.78-3.87-5.52-2.3-8.31,1.7-3.02,3.22-5.94,5.04-8.79Z"
          />
        </clipPath>
        <clipPath id="clippath-2">
          <path
            fill="none"
            d="m198.08,306.32c1.13.97,1.69,2.51,1.89,3.98.27,1.96-.52,3.89-1.28,5.71-1.01,2.41-2.02,4.85-3.53,6.99-1.51,2.14-2.81,2.97-5.32,3.71-3.15.93-13.22-2.73-14.38-3.41-1.42-.83-2.37-2.7-2.26-4.34.17-2.51-.24-5.13-.87-7.66-.63-2.51,1.28-5.1,2.97-7.05,1.57-1.82,3.97-2.21,6.23-3.01,2.96-1.05,6-3.07,8.55-1.12,2.76,2.1,5.43,4.01,8.01,6.22Z"
          />
        </clipPath>
        <clipPath id="clippath-3">
          <path
            fill="none"
            d="m137.34,268.99c1.13.97,1.69,2.51,1.89,3.98.27,1.96-.52,3.89-1.28,5.71-1.01,2.41-2.02,4.85-3.53,6.99-1.51,2.14-2.81,2.97-5.32,3.71-3.15.93-13.22-2.73-14.38-3.41-1.42-.83-2.37-2.7-2.26-4.34.17-2.51-.24-5.13-.87-7.66-.63-2.51,1.28-5.1,2.97-7.05,1.57-1.82,3.97-2.21,6.23-3.01,2.96-1.05,6-3.07,8.55-1.12,2.76,2.1,5.43,4.01,8.01,6.22Z"
          />
        </clipPath>
        <clipPath id="clippath-4">
          <path
            fill="none"
            d="m144.71,300.55c1.32.36,2.63.89,3.6,1.85,1.29,1.28,1.79,3.13,2.24,4.88.61,2.32,1.23,4.67,1.32,7.07.09,2.4-.39,4.9-1.81,6.83-1.79,2.43-4.79,3.66-7.76,4.24-1.53.3-3.12.45-4.64.13-1.48-.31-2.83-1.05-4.07-1.91-1.95-1.36-3.69-3.07-4.91-5.11s-1.91-4.43-1.76-6.81c.13-2.2.97-4.32,2.18-6.17,1.58-2.41,3.41-4.56,6.31-5.08,3.16-.57,6.17-.78,9.31.07Z"
          />
        </clipPath>
        <clipPath id="clippath-5">
          <path
            fill="none"
            d="m171.35,276.32c1.32.36,2.63.89,3.6,1.85,1.29,1.28,1.79,3.13,2.24,4.88.61,2.32,1.23,4.67,1.32,7.07.09,2.4-.39,4.9-1.81,6.83-1.79,2.43-4.79,3.66-7.76,4.24-1.53.3-3.12.45-4.64.13-1.48-.31-2.83-1.05-4.07-1.91-1.95-1.36-3.69-3.07-4.91-5.11s-1.91-4.43-1.76-6.81c.13-2.2.97-4.32,2.18-6.17,1.58-2.41,3.41-4.56,6.31-5.08,3.16-.57,6.17-.78,9.31.07Z"
          />
        </clipPath>
        <clipPath id="clippath-6">
          <path
            fill="none"
            d="m227.4,296.95c1.32.36,2.63.89,3.6,1.85,1.29,1.28,1.79,3.13,2.24,4.88.61,2.32,1.23,4.67,1.32,7.07.09,2.4-.39,4.9-1.81,6.83-1.79,2.43-4.79,3.66-7.76,4.24-1.53.3-3.12.45-4.64.13-1.48-.31-2.83-1.05-4.07-1.91-1.95-1.36-3.69-3.07-4.91-5.11s-1.91-4.43-1.76-6.81c.13-2.2.97-4.32,2.18-6.17,1.58-2.41,3.41-4.56,6.31-5.08,3.16-.57,6.17-.78,9.31.07Z"
          />
        </clipPath>
        <clipPath id="clippath-7">
          <path
            fill="none"
            d="m107.02,294.2c1.32.36,2.63.89,3.6,1.85,1.29,1.28,1.79,3.13,2.24,4.88.61,2.32,1.23,4.67,1.32,7.07.09,2.4-.39,4.9-1.81,6.83-1.79,2.43-4.79,3.66-7.76,4.24-1.53.3-3.12.45-4.64.13-1.48-.31-2.83-1.05-4.07-1.91-1.95-1.36-3.69-3.07-4.91-5.11s-1.91-4.43-1.76-6.81c.13-2.2.97-4.32,2.18-6.17,1.58-2.41,3.41-4.56,6.31-5.08,3.16-.57,6.17-.78,9.31.07Z"
          />
        </clipPath>
        <clipPath id="clippath-8">
          <path
            fill="#cbf4ff"
            d="m142.98,251.12l20.15,25.8-9.76,9.52-23.49-30.48c7.68-4.45,13.09-4.85,13.09-4.85Z"
          />
        </clipPath>
        <clipPath id="clippath-9">
          <path
            fill="#cbf4ff"
            d="m175.55,251.12l-52.68,67.84h18.42l47.02-61.94c-7.23-4.88-12.75-5.9-12.75-5.9Z"
          />
        </clipPath>
        <clipPath id="clippath-10">
          <path
            fill="none"
            d="m118.57,320.11c0-.17,0,3.07,0,2.9,0-4.82,1.03-24.2,1.03-24.2,0-1.18.81-2.14,1.81-2.14,0,0,9.52.66,38.3.66s37.8-.66,37.8-.66c1,0,1.81.96,1.81,2.14,0,0,.69,16.11.77,21.3h-81.53Z"
          />
        </clipPath>
      </defs>
      <g>
        <path
          fill="#cbf4ff"
          d="m92.46,320s9.12-28.22,14.13-38.23c7.79-15.53,18.76-24.74,33.1-28.87l20.3,27,23.32-24.8c12.41,5.33,22.97,14.82,30.3,27.07,6.46,10.79,13.92,37.83,13.92,37.83H92.46Z"
        />
        <g>
          <path
            fill="#cbf4ff"
            d="m92.46,320s9.12-28.22,14.13-38.23c7.79-15.53,18.76-24.74,33.1-28.87l20.3,27,23.32-24.8c12.41,5.33,22.97,14.82,30.3,27.07,6.46,10.79,13.92,37.83,13.92,37.83H92.46Z"
          />
          <g clip-path="url(#clippath)" fill="none">
            <ellipse
              fill="#afe76d"
              cx="127.68"
              cy="317.85"
              rx="6.76"
              ry="11.54"
              transform="translate(-165.06 140) rotate(-36.83)"
            />
            <ellipse
              fill="#afe76d"
              cx="110.81"
              cy="277.14"
              rx="11.54"
              ry="6.76"
              transform="translate(-187.21 293.61) rotate(-71.37)"
            />
            <ellipse
              fill="#afe76d"
              cx="186.44"
              cy="303.36"
              rx="6.76"
              ry="11.54"
              transform="translate(-144.65 172.33) rotate(-36.83)"
            />
            <ellipse
              fill="#afe76d"
              cx="218.06"
              cy="322.18"
              rx="6.76"
              ry="11.54"
              transform="translate(-149.62 195.05) rotate(-36.83)"
            />
            <g>
              <path
                fill="#70cef8"
                d="m145.25,309.59c2.43,5.92,5.76,14.59,8.08,20.67,2.85,6.88,5.29,13.85,6.09,21.34,0,0-.28.1-.28.1-3.9-6.45-6.18-13.46-8.08-20.67,0,0-3.11-10.65-3.11-10.65-.99-3.56-2.02-7.12-2.97-10.69,0,0,.28-.1.28-.1h0Z"
              />
              <path
                fill="#70cef8"
                d="m148.02,303.66c2.65,6.57,6.29,16.18,8.83,22.91,3.1,7.63,5.79,15.34,6.84,23.58,0,0-.28.1-.28.1-4.15-7.2-6.68-14.96-8.83-22.91,0,0-3.49-11.77-3.49-11.77-1.11-3.94-2.27-7.86-3.35-11.81,0,0,.28-.1.28-.1h0Z"
              />
              <path
                fill="#70cef8"
                d="m150.5,296.87c2.91,7.34,6.93,18.07,9.73,25.58,3.4,8.51,6.39,17.12,7.74,26.26,0,0-.28.1-.28.1-4.46-8.09-7.28-16.75-9.73-25.58,0,0-3.94-13.1-3.94-13.1-1.26-4.38-2.57-8.75-3.8-13.15,0,0,.28-.1.28-.1h0Z"
              />
              <path
                fill="#70cef8"
                d="m152.73,289.34c3.21,8.22,7.66,20.22,10.76,28.63,3.74,9.53,7.08,19.14,8.77,29.3,0,0-.28.1-.28.1-4.8-9.11-7.97-18.78-10.76-28.63,0,0-4.46-14.63-4.46-14.63-1.44-4.89-2.91-9.77-4.31-14.67l.28-.1h0Z"
              />
              <path
                fill="#70cef8"
                d="m155.74,284.15c3.39,8.76,8.1,21.55,11.39,30.5,3.95,10.15,7.5,20.39,9.4,31.17,0,0-.28.1-.28.1-5.01-9.73-8.39-20.03-11.39-30.5,0,0-4.77-15.56-4.77-15.56-1.54-5.2-3.12-10.39-4.63-15.61,0,0,.28-.1.28-.1h0Z"
              />
            </g>
            <g>
              <path
                fill="#70cef8"
                d="m120.28,304.31c-1.65,6.19-4.25,15.1-6.09,21.34-1.9,7.2-4.18,14.22-8.07,20.67,0,0-.28-.1-.28-.1.8-7.49,3.23-14.46,6.09-21.34,0,0,3.97-10.36,3.97-10.36,1.37-3.44,2.7-6.89,4.11-10.31,0,0,.28.1.28.1h0Z"
              />
              <path
                fill="#70cef8"
                d="m117.51,298.38c-1.87,6.83-4.79,16.69-6.84,23.58-2.15,7.95-4.68,15.71-8.83,22.91,0,0-.28-.1-.28-.1,1.05-8.24,3.74-15.95,6.84-23.58,0,0,4.34-11.48,4.34-11.48,1.5-3.81,2.95-7.63,4.49-11.43,0,0,.28.1.28.1h0Z"
              />
              <path
                fill="#70cef8"
                d="m115.03,291.59c-2.13,7.61-5.42,18.58-7.74,26.25-2.45,8.83-5.28,17.49-9.73,25.58,0,0-.28-.1-.28-.1,1.35-9.14,4.34-17.74,7.74-26.26,0,0,4.8-12.82,4.8-12.82,1.65-4.26,3.25-8.52,4.94-12.77l.28.1h0Z"
              />
              <path
                fill="#70cef8"
                d="m112.8,284.06c-2.42,8.48-6.15,20.73-8.77,29.3-2.79,9.84-5.96,19.52-10.76,28.63,0,0-.28-.1-.28-.1,1.69-10.15,5.03-19.77,8.77-29.3,0,0,5.31-14.34,5.31-14.34,1.82-4.76,3.6-9.54,5.45-14.29l.28.1h0Z"
              />
              <path
                fill="#70cef8"
                d="m109.78,278.87c-2.6,9.02-6.6,22.06-9.4,31.17-3,10.47-6.38,20.77-11.39,30.5,0,0-.28-.1-.28-.1,1.9-10.78,5.45-21.02,9.4-31.17,0,0,5.62-15.27,5.62-15.27,1.92-5.08,3.81-10.16,5.77-15.23,0,0,.28.1.28.1h0Z"
              />
            </g>
            <g>
              <path
                fill="#70cef8"
                d="m180.4,290.3c-5.38-3.46-13.07-8.68-18.45-12.33-6.28-4.01-12.26-8.33-17.2-14.02,0,0,.18-.24.18-.24,6.89,3.06,12.77,7.51,18.45,12.33,0,0,8.64,6.95,8.64,6.95,2.85,2.36,5.73,4.68,8.55,7.07l-.18.24h0Z"
              />
              <path
                fill="#70cef8"
                d="m186.89,289.48c-5.93-3.87-14.42-9.67-20.35-13.74-6.91-4.48-13.52-9.27-19.1-15.43,0,0,.18-.24.18-.24,7.52,3.53,14.04,8.45,20.35,13.74,0,0,9.59,7.65,9.59,7.65,3.17,2.59,6.36,5.15,9.51,7.77,0,0-.18.24-.18.24h0Z"
              />
              <path
                fill="#70cef8"
                d="m194.11,289.2c-6.59-4.35-16.02-10.86-22.62-15.42-7.66-5.04-15.04-10.38-21.37-17.1,0,0,.18-.24.18-.24,8.28,4.09,15.56,9.57,22.62,15.42,0,0,10.73,8.49,10.73,8.49,3.55,2.87,7.12,5.71,10.64,8.61,0,0-.18.24-.18.24h0Z"
              />
              <path
                fill="#70cef8"
                d="m201.96,289.39c-7.33-4.9-17.85-12.21-25.2-17.32-8.52-5.67-16.76-11.65-23.95-19.01,0,0,.18-.24.18-.24,9.15,4.72,17.28,10.85,25.2,17.32,0,0,12.02,9.45,12.02,9.45,3.98,3.19,7.98,6.35,11.93,9.57l-.18.24h0Z"
              />
              <path
                fill="#70cef8"
                d="m207.83,288.1c-7.79-5.24-18.98-13.04-26.79-18.5-9.04-6.06-17.82-12.44-25.54-20.19,0,0,.18-.24.18-.24,9.68,5.12,18.34,11.63,26.79,18.5,0,0,12.82,10.03,12.82,10.03,4.24,3.39,8.51,6.74,12.73,10.15l-.18.24h0Z"
              />
            </g>
            <g>
              <path
                fill="#70cef8"
                d="m212.82,308.26c5.65-3.01,13.95-7.19,19.76-10.1,6.56-3.52,13.25-6.64,20.62-8.19,0,0,.12.27.12.27-6.02,4.52-12.78,7.49-19.76,10.1,0,0-10.28,4.16-10.28,4.16-3.45,1.34-6.88,2.72-10.34,4.02l-.12-.27h0Z"
              />
              <path
                fill="#70cef8"
                d="m206.65,306.09c6.27-3.29,15.47-7.88,21.91-11.07,7.28-3.85,14.68-7.29,22.78-9.16,0,0,.12.27.12.27-6.74,4.85-14.22,8.14-21.91,11.07,0,0-11.36,4.65-11.36,4.65-3.81,1.5-7.6,3.04-11.42,4.51l-.12-.27h0Z"
              />
              <path
                fill="#70cef8"
                d="m199.64,304.31c7.01-3.63,17.29-8.7,24.48-12.24,8.13-4.23,16.39-8.07,25.35-10.33,0,0,.12.27.12.27-7.6,5.24-15.94,8.92-24.48,12.24,0,0-12.64,5.23-12.64,5.23-4.24,1.7-8.45,3.43-12.71,5.09,0,0-.12-.27-.12-.27h0Z"
              />
              <path
                fill="#70cef8"
                d="m191.93,302.84c7.86-4.01,19.36-9.64,27.41-13.56,9.1-4.67,18.34-8.95,28.28-11.65,0,0,.12.27.12.27-8.58,5.69-17.89,9.8-27.41,13.56,0,0-14.11,5.89-14.11,5.89-4.72,1.92-9.43,3.87-14.17,5.76,0,0-.12-.27-.12-.27h0Z"
              />
              <path
                fill="#70cef8"
                d="m186.46,300.36c8.38-4.25,20.63-10.21,29.21-14.38,9.7-4.94,19.54-9.49,30.08-12.47,0,0,.12.27.12.27-9.18,5.96-19.1,10.35-29.21,14.38,0,0-15.01,6.3-15.01,6.3-5.02,2.05-10.03,4.15-15.07,6.16l-.12-.27h0Z"
              />
            </g>
            <g>
              <path
                fill="#70cef8"
                d="m136.01,280.01c5.65-3.01,13.95-7.19,19.76-10.1,6.56-3.52,13.25-6.64,20.62-8.19,0,0,.12.27.12.27-6.02,4.52-12.78,7.49-19.76,10.1,0,0-10.28,4.16-10.28,4.16-3.45,1.34-6.88,2.72-10.34,4.02l-.12-.27h0Z"
              />
              <path
                fill="#70cef8"
                d="m129.84,277.84c6.27-3.3,15.47-7.88,21.91-11.07,7.28-3.85,14.68-7.29,22.78-9.16,0,0,.12.27.12.27-6.74,4.85-14.22,8.14-21.91,11.07,0,0-11.36,4.65-11.36,4.65-3.81,1.5-7.6,3.04-11.42,4.51l-.12-.27h0Z"
              />
              <path
                fill="#70cef8"
                d="m122.84,276.06c7.01-3.63,17.29-8.7,24.48-12.24,8.13-4.23,16.39-8.07,25.35-10.33,0,0,.12.27.12.27-7.6,5.24-15.94,8.92-24.48,12.24,0,0-12.64,5.23-12.64,5.23-4.24,1.7-8.45,3.43-12.71,5.09,0,0-.12-.27-.12-.27h0Z"
              />
              <path
                fill="#70cef8"
                d="m115.12,274.59c7.86-4.01,19.36-9.64,27.41-13.56,9.1-4.67,18.34-8.95,28.28-11.65,0,0,.12.27.12.27-8.58,5.69-17.89,9.8-27.41,13.56,0,0-14.11,5.89-14.11,5.89-4.72,1.92-9.43,3.87-14.17,5.76l-.12-.27h0Z"
              />
              <path
                fill="#70cef8"
                d="m109.66,272.1c8.38-4.25,20.63-10.22,29.21-14.38,9.7-4.94,19.54-9.5,30.08-12.47,0,0,.12.27.12.27-9.18,5.96-19.1,10.35-29.21,14.38,0,0-15.01,6.3-15.01,6.3-5.02,2.05-10.03,4.15-15.07,6.16,0,0-.12-.27-.12-.27h0Z"
              />
            </g>
            <g>
              <g clip-path="url(#clippath-1)" fill="none">
                <rect
                  fill="#70bbf9"
                  x="185.66"
                  y="256.21"
                  width="29.3"
                  height="28.75"
                />
                <circle fill="#70bbf9" cx="200.38" cy="270.41" r="13.77" />
                <circle fill="#7fc6fa" cx="200.38" cy="270.41" r="11.81" />
                <circle fill="#8ed2fb" cx="200.38" cy="270.41" r="9.85" />
                <circle fill="#9dddfc" cx="200.38" cy="270.41" r="7.89" />
                <circle fill="#abe8fd" cx="200.38" cy="270.41" r="5.92" />
                <circle fill="#baf4fe" cx="200.38" cy="270.41" r="3.96" />
                <circle fill="#c9ffff" cx="200.38" cy="270.41" r="2" />
              </g>
              <path
                fill="#fff"
                d="m211.47,262.89c-3.93,1.06-9.44,4.08-10.53,5.36-1.87-2.7-3.44-5.42-5.31-8.12.41,2.33,2.66,8.68,2.67,8.72-.56-.02-5.91-.49-9.65,2.46,0,0,8.62-.84,9.63.24-.5,1.16-1.05,6.88-.84,10.4,1.19-6.19,3.72-9.72,3.72-9.72l-.48-.08c2.79,2.6,6.38,5.45,9.04,8.05-3.09-4.93-5.19-8.18-7.01-9.72,2.2-3.85,8.45-7.51,8.74-7.59Z"
              />
            </g>
            <g>
              <g clip-path="url(#clippath-2)" fill="none">
                <rect
                  fill="#70bbf9"
                  x="171.7"
                  y="298.17"
                  width="28.54"
                  height="29.47"
                />
                <circle fill="#70bbf9" cx="185.83" cy="312.79" r="13.77" />
                <circle fill="#7fc6fa" cx="185.83" cy="312.79" r="11.81" />
                <circle fill="#8ed2fb" cx="185.83" cy="312.79" r="9.85" />
                <circle fill="#9dddfc" cx="185.83" cy="312.79" r="7.89" />
                <circle fill="#abe8fd" cx="185.83" cy="312.79" r="5.92" />
                <circle fill="#baf4fe" cx="185.83" cy="312.79" r="3.96" />
                <circle fill="#c9ffff" cx="185.83" cy="312.79" r="2" />
              </g>
              <path
                fill="#fff"
                d="m191.73,324.82c-.5-4.04-2.73-9.91-3.85-11.17,2.93-1.47,5.85-2.66,8.78-4.13-2.36.08-8.97,1.43-9,1.44.09-.55,1.3-5.78-1.1-9.89,0,0-.37,8.65-1.58,9.51-1.08-.66-6.67-2-10.18-2.28,5.96,2.04,9.11,5.04,9.11,5.04l.15-.46c-2.96,2.4-6.29,5.56-9.23,7.83,5.31-2.37,8.82-4,10.6-5.59,3.5,2.71,6.26,9.41,6.3,9.71Z"
              />
            </g>
            <g>
              <g clip-path="url(#clippath-3)" fill="none">
                <rect
                  fill="#70bbf9"
                  x="110.95"
                  y="260.84"
                  width="28.54"
                  height="29.47"
                />
                <circle fill="#70bbf9" cx="125.08" cy="275.46" r="13.77" />
                <circle fill="#7fc6fa" cx="125.08" cy="275.46" r="11.81" />
                <circle fill="#8ed2fb" cx="125.08" cy="275.46" r="9.85" />
                <circle fill="#9dddfc" cx="125.08" cy="275.46" r="7.89" />
                <circle fill="#abe8fd" cx="125.08" cy="275.46" r="5.92" />
                <circle fill="#baf4fe" cx="125.08" cy="275.46" r="3.96" />
                <circle fill="#c9ffff" cx="125.08" cy="275.46" r="2" />
              </g>
              <path
                fill="#fff"
                d="m130.99,287.49c-.5-4.04-2.73-9.91-3.85-11.17,2.93-1.47,5.85-2.66,8.78-4.13-2.36.08-8.97,1.43-9,1.44.09-.55,1.3-5.78-1.1-9.89,0,0-.37,8.65-1.58,9.51-1.08-.66-6.67-2-10.18-2.28,5.96,2.04,9.11,5.04,9.11,5.04l.15-.46c-2.96,2.4-6.29,5.56-9.23,7.83,5.31-2.37,8.82-4,10.6-5.59,3.5,2.71,6.26,9.41,6.3,9.71Z"
              />
            </g>
            <g>
              <g clip-path="url(#clippath-4)" fill="none">
                <rect
                  fill="#70bbf9"
                  x="126.77"
                  y="299.7"
                  width="25.2"
                  height="26.18"
                />
                <circle fill="#70bbf9" cx="139.85" cy="312.68" r="12.91" />
                <circle fill="#7fc6fa" cx="139.85" cy="312.68" r="11.07" />
                <circle fill="#8ed2fb" cx="139.85" cy="312.68" r="9.23" />
                <circle fill="#9dddfc" cx="139.85" cy="312.68" r="7.39" />
                <circle fill="#abe8fd" cx="139.85" cy="312.68" r="5.55" />
                <circle fill="#baf4fe" cx="139.85" cy="312.68" r="3.71" />
                <circle fill="#c9ffff" cx="139.85" cy="312.68" r="1.87" />
              </g>
              <path
                fill="#fff"
                d="m150.39,317.59c-2.62-2.67-7.51-5.71-9.03-6.01,1.32-2.71,2.79-5.2,4.11-7.91-1.68,1.38-5.75,6.04-5.77,6.07-.24-.45-2.27-4.95-6.32-6.61,0,0,4.55,6.52,4.15,7.82-1.16.13-5.98,2.26-8.7,4.01,5.49-1.84,9.46-1.4,9.46-1.4l-.15-.42c-.82,3.4-1.49,7.56-2.37,10.86,2.55-4.69,4.21-7.84,4.62-9.99,4.07.03,9.82,3.38,10.01,3.58Z"
              />
            </g>
            <g>
              <ellipse
                fill="#afe76d"
                cx="145.93"
                cy="292.11"
                rx="11.54"
                ry="6.76"
                transform="translate(-91.13 67.55) rotate(-20.01)"
              />
              <g clip-path="url(#clippath-5)" fill="none">
                <rect
                  fill="#70bbf9"
                  x="153.41"
                  y="275.46"
                  width="25.2"
                  height="26.18"
                />
                <circle fill="#70bbf9" cx="166.49" cy="288.44" r="12.91" />
                <circle fill="#7fc6fa" cx="166.49" cy="288.44" r="11.07" />
                <circle fill="#8ed2fb" cx="166.49" cy="288.44" r="9.23" />
                <circle fill="#9dddfc" cx="166.49" cy="288.44" r="7.39" />
                <circle fill="#abe8fd" cx="166.49" cy="288.44" r="5.55" />
                <circle fill="#baf4fe" cx="166.49" cy="288.44" r="3.71" />
                <circle fill="#c9ffff" cx="166.49" cy="288.44" r="1.87" />
              </g>
              <path
                fill="#fff"
                d="m177.02,293.36c-2.62-2.67-7.51-5.71-9.03-6.01,1.32-2.71,2.79-5.2,4.11-7.91-1.68,1.38-5.75,6.04-5.77,6.07-.24-.45-2.27-4.95-6.32-6.61,0,0,4.55,6.52,4.15,7.82-1.16.13-5.98,2.26-8.7,4.01,5.49-1.84,9.46-1.4,9.46-1.4l-.15-.42c-.82,3.4-1.49,7.56-2.37,10.86,2.55-4.69,4.21-7.84,4.62-9.99,4.07.03,9.82,3.38,10.01,3.58Z"
              />
            </g>
            <g>
              <g clip-path="url(#clippath-6)" fill="none">
                <rect
                  fill="#70bbf9"
                  x="209.46"
                  y="296.09"
                  width="25.2"
                  height="26.18"
                />
                <circle fill="#70bbf9" cx="222.08" cy="309.25" r="12.69" />
                <circle fill="#7fc6fa" cx="222.08" cy="309.25" r="10.88" />
                <circle fill="#8ed2fb" cx="222.08" cy="309.25" r="9.07" />
                <circle fill="#9dddfc" cx="222.08" cy="309.25" r="7.26" />
                <circle fill="#abe8fd" cx="222.08" cy="309.25" r="5.46" />
                <circle fill="#baf4fe" cx="222.08" cy="309.25" r="3.65" />
                <circle fill="#c9ffff" cx="222.08" cy="309.25" r="1.84" />
              </g>
              <path
                fill="#fff"
                d="m233.08,313.99c-2.62-2.67-7.51-5.71-9.03-6.01,1.32-2.71,2.79-5.2,4.11-7.91-1.68,1.38-5.75,6.04-5.77,6.07-.24-.45-2.27-4.95-6.32-6.61,0,0,4.55,6.52,4.15,7.82-1.16.13-5.98,2.26-8.7,4.01,5.49-1.84,9.46-1.4,9.46-1.4l-.15-.42c-.82,3.4-1.49,7.56-2.37,10.86,2.55-4.69,4.21-7.84,4.62-9.99,4.07.03,9.82,3.38,10.01,3.58Z"
              />
            </g>
            <g>
              <g clip-path="url(#clippath-7)" fill="none">
                <rect
                  fill="#70bbf9"
                  x="89.08"
                  y="293.35"
                  width="25.2"
                  height="26.18"
                />
                <circle fill="#70bbf9" cx="102.16" cy="306.32" r="12.91" />
                <circle fill="#7fc6fa" cx="102.16" cy="306.32" r="11.07" />
                <circle fill="#8ed2fb" cx="102.16" cy="306.32" r="9.23" />
                <circle fill="#9dddfc" cx="102.16" cy="306.32" r="7.39" />
                <circle fill="#abe8fd" cx="102.16" cy="306.32" r="5.55" />
                <circle fill="#baf4fe" cx="102.16" cy="306.32" r="3.71" />
                <circle fill="#c9ffff" cx="102.16" cy="306.32" r="1.87" />
              </g>
              <path
                fill="#fff"
                d="m112.69,311.24c-2.62-2.67-7.51-5.71-9.03-6.01,1.32-2.71,2.79-5.2,4.11-7.91-1.68,1.38-5.75,6.04-5.77,6.07-.24-.45-2.27-4.95-6.32-6.61,0,0,4.55,6.52,4.15,7.82-1.16.13-5.98,2.26-8.7,4.01,5.49-1.84,9.46-1.4,9.46-1.4l-.15-.42c-.82,3.4-1.49,7.56-2.37,10.86,2.55-4.69,4.21-7.84,4.62-9.99,4.07.03,9.82,3.38,10.01,3.58Z"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            fill="#cbf4ff"
            d="m142.98,251.12l20.15,25.8-9.76,9.52-23.49-30.48c7.68-4.45,13.09-4.85,13.09-4.85Z"
          />
          <g clip-path="url(#clippath-8)" fill="none">
            <g>
              <path
                fill="#70cef8"
                d="m138.48,272.42c4.53,4.52,10.95,11.24,15.43,15.95,5.29,5.25,10.22,10.73,13.85,17.33,0,0-.23.2-.23.2-6.09-4.44-10.9-10.03-15.43-15.95,0,0-6.98-8.62-6.98-8.62-2.29-2.91-4.61-5.78-6.87-8.72,0,0,.23-.2.23-.2h0Z"
              />
              <path
                fill="#70cef8"
                d="m138.75,265.89c4.98,5.03,12.05,12.49,16.99,17.72,5.8,5.84,11.27,11.91,15.42,19.11,0,0-.23.2-.23.2-6.61-5.03-11.94-11.22-16.99-17.72,0,0-7.76-9.5-7.76-9.5-2.55-3.2-5.13-6.38-7.65-9.6l.23-.2h0Z"
              />
              <path
                fill="#70cef8"
                d="m138.41,258.66c5.52,5.65,13.37,13.99,18.86,19.84,6.42,6.54,12.51,13.32,17.28,21.23,0,0-.23.2-.23.2-7.23-5.74-13.19-12.64-18.86-19.84,0,0-8.7-10.56-8.7-10.56-2.86-3.56-5.75-7.08-8.58-10.66l.23-.2h0Z"
              />
              <path
                fill="#70cef8"
                d="m137.56,250.86c6.13,6.34,14.87,15.7,20.98,22.25,7.13,7.34,13.92,14.93,19.4,23.64,0,0-.23.2-.23.2-7.95-6.55-14.6-14.25-20.98-22.25,0,0-9.76-11.77-9.76-11.77-3.21-3.96-6.46-7.89-9.65-11.87l.23-.2h0Z"
              />
              <path
                fill="#70cef8"
                d="m138.34,244.91c6.51,6.77,15.8,16.75,22.29,23.74,7.56,7.83,14.79,15.91,20.71,25.12,0,0-.23.2-.23.2-8.38-7.04-15.48-15.24-22.29-23.74,0,0-10.41-12.51-10.41-12.51-3.43-4.21-6.9-8.38-10.3-12.61l.23-.2h0Z"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            fill="#cbf4ff"
            d="m175.55,251.12l-52.68,67.84h18.42l47.02-61.94c-7.23-4.88-12.75-5.9-12.75-5.9Z"
          />
          <g clip-path="url(#clippath-9)" fill="none">
            <ellipse
              fill="#afe76d"
              cx="183.96"
              cy="268.86"
              rx="6.76"
              ry="11.54"
              transform="translate(-114.53 138.36) rotate(-32)"
            />
          </g>
        </g>
        <g opacity=".31" fill="none">
          <polygon
            fill="#423a58"
            points="188.6 320 177.3 320 177.3 311 187.2 311 188.6 320"
          />
        </g>
        <path
          fill="#d04646"
          d="m125.67,286.2s0,.05.04.04c0-.02,0-.04-.04-.04Z"
        />
        <path
          fill="#e17b7b"
          isolation="isolate"
          opacity=".33"
          d="m125.67,286.2s0,.05.04.04c0-.02,0-.04-.04-.04Z"
        />
        <path
          fill="#d04646"
          d="m116.87,286.8s-.05,0-.04.04c.02,0,.04,0,.04-.04Z"
        />
        <path
          fill="#e17b7b"
          isolation="isolate"
          opacity=".33"
          d="m116.87,286.8s-.05,0-.04.04c.02,0,.04,0,.04-.04Z"
        />
        <path fill="#d04646" d="m114.07,283v-.1s-.1.1,0,.1Z" />
        <path
          fill="#e17b7b"
          isolation="isolate"
          opacity=".33"
          d="m114.07,283v-.1s-.1.1,0,.1Z"
        />
        <path
          fill="#d04646"
          d="m130.87,280.1s0,.05.04.04c0-.02,0-.04-.04-.04Z"
        />
        <polygon
          fill="#d04646"
          points="125.47 262 125.44 261.97 125.37 262.1 125.47 262"
        />
        <polygon
          fill="#e17b7b"
          isolation="isolate"
          opacity=".33"
          points="125.47 262 125.44 261.97 125.37 262.1 125.47 262"
        />
        <path
          fill="#e17b7b"
          isolation="isolate"
          opacity=".33"
          d="m197.53,263.66s.02.02.04.03c0-.01-.01-.03-.04-.03Z"
        />
        <path
          fill="#d04646"
          d="m201.64,270.66s.06-.02.08-.03c-.03.01-.06.02-.08.03Z"
        />
        <path
          fill="#d04646"
          d="m197.58,263.7s-.01,0-.02-.01c0,0,0,.01,0,.01h.01Z"
        />
        <path
          fill="#d04646"
          d="m202.68,270.41c-.21,0-.41.03-.61.09-.12.03-.23.08-.34.13.14-.06.29-.11.44-.13.17-.05.34-.08.51-.09Z"
        />
        <path
          fill="#ffef39"
          d="m119.8,320.08c0-.17.4-.4.4-.57,0-4.73,1.02-20.74,1.02-20.74,0-1.16.79-2.1,1.77-2.1,0,0,9.32.64,37.49.64s36.99-.64,36.99-.64c.98,0,1.77.94,1.77,2.1,0,0,.27,16.22.35,21.31h-79.79Z"
        />
        <g clip-path="url(#clippath-10)" fill="none">
          <polygon
            fill="#ffd631"
            points="119.49 322.18 213.03 293.92 120.73 325.98 119.49 322.18 119.49 322.18"
          />
        </g>
      </g>
    </g>
  </fragment>
</template>

<script>
export default {
  name: 'avatarShirtsC',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
